const en = {
  // General
  loading: "Loading...",
  organizationLoadError: "Organization data could not be loaded.",
  organizationTitle: "Organization Engine",
  organizationSubtitle: "Position templates, users and personnel linkage status.",
  organizationPositionsLabel: "Positions",
  organizationUsersLabel: "Users",
  organizationPersonnelLabel: "Personnel",
  organizationUnassignedUsersLabel: "Unassigned Users",
  organizationPositionsTitle: "Organization Positions",
  organizationDepartment: "Department",
  organizationSubDepartment: "Sub Department",
  organizationJobTitle: "Title",
  organizationLevel: "Level",
  organizationRole: "Role",
  organizationUser: "User",
  organizationUnassigned: "Unassigned",
  organizationUnassignedUsersTitle: "Unassigned Users",
  organizationUnlinkedPersonnelTitle: "Personnel Without User Accounts",
  organizationTenant: "Tenant",
  organizationFullName: "Full Name",
  organizationDepartmentNameRequired: "Department name is required.",
  organizationDepartmentSaveFailed: "Department could not be saved.",
  organizationDepartmentStatusFailed: "Department status could not be changed.",
  organizationSelectDepartment: "Please select a department.",
  organizationPositionTitleRequired: "Position title is required.",
  organizationPositionSaveFailed: "Position could not be saved.",
  organizationPositionStatusFailed: "Position status could not be changed.",
  organizationDepartmentNamePlaceholder: "Department name",
  organizationPositionTitlePlaceholder: "Position title",
  organizationOrderPlaceholder: "Order",
  organizationCodePlaceholder: "Code",
  organizationSubDepartmentPlaceholder: "Sub-department",
  organizationRoleCodePlaceholder: "Role code",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  add: "Add",
  search: "Search",
  refresh: "Refresh",
  close: "Close",
  confirm: "Confirm",
  reject: "Reject",
  total: "Total",
  status: "Status",
  date: "Date",
  notes: "Notes",
  actions: "Actions",
  detail: "Detail",
  create: "Create",
  update: "Update",
  success: "Success",
  error: "Error",
  warning: "Warning",
  logout: "Logout",
  quantity: "Quantity",
  unit: "Unit",
  price: "Price",
  customer: "Customer",
  supplier: "Supplier",
  product: "Product",
  machine: "Machine",
  operator: "Operator",
  department: "Department",
  priority: "Priority",
  category: "Category",
  description: "Description",
  noData: "No data found.",
  noMatch: "No matching records found.",
  products: "Product Cards",
  // Menu
  menu: {
    dashboard: "Dashboard",
    machines: "Machines",
    workorders: "Work Orders",
    scrap: "Scrap & Recycling",
    quality: "Quality & Shipment",
    assembly: "Assembly",
    stock: "Stock",
    maintenance: "Maintenance & Service",
    energy: "Energy",
    kaizen: "Kaizen",
    lean: "Lean",
    fives: "5S Audit",
    hr: "HR & Payroll",
    reports: "Reports",
    shifts: "Shift Planning",
    admin: "Factory Panel",
    users: "User Management",
    organization: "Organization",
    salesorders: "Sales Orders",
    purchasing: "Purchasing",
    products: "Product Cards",
    qualityCost: "Quality Cost",
  },

  superAdmin: {
    menu: {
      dashboard: "Dashboard",
      tenants: "Companies",
      users: "Users",
      licenses: "Licenses",
      payments: "Payments",
      crm: "CRM",
      health: "Server Health",
      backups: "Backups",
      edge: "Edge Manager",
    },

    superAdminTitle: "Super Admin",
    saasOverview: "SaaS Management Overview",
    upcomingWork: "Upcoming Work",
    upcomingLicenseCenter: "🧾 License center will be prepared",
    upcomingPaymentArchitecture: "💳 Stripe + Iyzico architecture will be implemented",
    upcomingCrmPipeline: "🤝 CRM pipeline will be added",
    upcomingServerHealth: "🖥️ Server health screen will be added",

    tenantManagement: "Company Management",
    loading: "Loading...",
    plan: "Plan",
    user: "User",
    dataSource: "Data Source",
    license: "License",
    signIn: "Sign In",
    edit: "Edit",
    extend: "Extend",
    delete: "Delete",

    licenseCenter: "License Center",
    packageLicenseSubtitle: "Trial, Essentials, Professional, Advanced and Enterprise packages with license renewal status",
    packageMatrixTitle: "Commercial Packages",
    packageMatrixSubtitle: "Module and capacity coverage of active packages",
    packageEssentialsDesc: "Essentials package for live factory and machine visibility, Dashboard and core operational reporting.",
    packageProfessionalDesc: "Essentials capabilities plus production management, work orders, quality, assembly, shifts and business operations.",
    packageAdvancedDesc: "Professional capabilities plus maintenance, energy, cost of quality, Kaizen, Lean and 5S optimization.",
    packageEnterpriseDesc: "Advanced capabilities plus enterprise scale, integrations, custom configuration and advanced management.",
    erpConnector: "ERP Connector",
    erpConnectorTitle: "ERP Connector Management",
    erpConnectorManage: "ERP Connector",
    erpConnectorEnabled: "Enabled",
    erpConnectorDisabled: "Disabled",
    erpConnectorGrantType: "Grant Type",
    erpConnectorGrantAddon: "Paid Add-on",
    erpConnectorGrantGift: "Gift",
    erpConnectorGrantTrial: "Trial",
    erpConnectorGrantManual: "Manual",
    erpConnectorCurrency: "Currency",
    erpConnectorMonthlyPrice: "Monthly Price",
    erpConnectorYearlyPrice: "Yearly Price",
    erpConnectorStartsAt: "Start Date",
    erpConnectorExpiresAt: "End Date",
    erpConnectorNotes: "Notes",
    erpConnectorNotesPlaceholder: "ERP system, integration scope or commercial notes...",
    erpConnectorSave: "Save ERP Connector",
    erpConnectorSaved: "ERP Connector updated.",
    erpConnectorSaveFailed: "ERP Connector could not be saved.",
    erpConnectorConnectionError: "ERP Connector connection error.",
    erpConnectorTenantMissing: "Company information is missing.",
    erpConnectorInvalidPrice: "Enter a valid price.",
    erpConnectorPrice: "ERP Connector Price",
    erpConnectorMonthly: "month",

    moduleAddonManage: "Additional Modules",
    moduleAddonTitle: "Additional Module Management",
    moduleAddonSubtitle: "Tenant-specific module entitlements and commercial terms on top of the base package",
    moduleAddonModule: "Module",
    moduleAddonEnabled: "Enabled",
    moduleAddonGrantType: "Grant Type",
    moduleAddonGrantAddon: "Paid Add-on",
    moduleAddonGrantGift: "Gift",
    moduleAddonGrantTrial: "Trial",
    moduleAddonGrantManual: "Manual",
    moduleAddonCurrency: "Currency",
    moduleAddonMonthlyPrice: "Monthly Price",
    moduleAddonYearlyPrice: "Yearly Price",
    moduleAddonStartsAt: "Start Date",
    moduleAddonExpiresAt: "End Date",
    moduleAddonNotes: "Notes",
    moduleAddonNotesPlaceholder: "Commercial scope or customer-specific note...",
    moduleAddonSave: "Save Additional Module",
    moduleAddonSaved: "Additional module updated.",
    moduleAddonDeleted: "Additional module removed.",
    moduleAddonLoadFailed: "Additional modules could not be loaded.",
    moduleAddonSaveFailed: "Additional module could not be saved.",
    moduleAddonDeleteFailed: "Additional module could not be removed.",
    moduleAddonDeleteConfirm: "Remove this additional module record?",
    moduleAddonModuleRequired: "Select a module.",
    moduleAddonInvalidPrice: "Enter a valid price.",
    moduleAddonCurrent: "Configured Additional Modules",
    moduleAddonNone: "No additional module is configured for this company.",
    moduleAddonEdit: "Edit",
    moduleAddonRemove: "Remove",
    userLimit: "User Limit",
    machineLimit: "Machine Limit",
    usersCommercial: "Users",
    unlimited: "Unlimited",
    machineLicensing: "Licensing",
    perMachineMonthly: "Per machine / monthly",
    machinePricingTitle: "Per-Machine Pricing",
    machinePricingSubtitle: "Monthly per-machine price catalog for Essentials, Professional, Advanced and Enterprise packages",
    machinePriceEdit: "Edit Prices",
    machinePriceModalTitle: "Per-Machine Price",
    machinePriceMonthly: "Machine / Month",
    machinePriceNotConfigured: "Not configured",
    machinePriceHelp: "These prices represent the monthly license fee for one machine by package. Users are unlimited. ERP Connector is priced separately.",
    machinePriceSave: "Save Prices",
    machinePriceSaved: "Per-machine prices updated.",
    machinePriceSaveFailed: "Per-machine prices could not be saved.",
    machinePriceInvalid: "Enter valid zero or positive prices for TRY, USD and EUR.",
    machinePricePlanMissing: "Package information is missing.",
    editPlan: "Edit Plan",
    editLicense: "Edit License",
    noPlan: "No plan",
    renewalSoon: "Renewal Due Soon",
    expired: "Expired",
    planTrial: "Trial",
    realMachine: "Real Machine",
    simulation: "Simulation",
    days: "days",

    price: "Price",
    endDate: "End Date",
    status: "Status",
    unknown: "Unknown",
    daysRemaining: "days remaining",
    limit: "Limit",
    usersUnit: "users",
    machinesUnit: "machines",
    email: "Email",

    paymentCenter: "Payment Center",
    paymentArchitecture: "Payment Architecture",
    paymentTryInfo: "🇹🇷 TRY payments: Iyzico subscription / payment link",
    paymentForeignInfo: "🌍 USD / EUR payments: Stripe Checkout / Subscription",
    paymentLicenseLinkInfo: "🧾 Every payment will be linked to the tenant license period",
    paymentWebhookInfo: "🔐 Webhook verification will be handled by the backend",

    tryCollection: "TRY Collection",
    tryCollectionDesc: "Iyzico for customers in Türkiye",
    usdCollection: "USD Collection",
    usdCollectionDesc: "Stripe for international customers",
    eurCollection: "EUR Collection",
    eurCollectionDesc: "Stripe for European customers",

    crmPipeline: "CRM Pipeline",
    crmLeadApiPending: "Lead creation API will be added in the next step",
    crmLead: "Lead",
    crmLeadDesc: "Initial contact / potential customer",
    crmDemo: "Demo",
    crmDemoDesc: "Company with a scheduled or completed demo",
    crmTrial: "Trial",
    crmTrialDesc: "Company with an active trial account",
    crmCustomer: "Customer",
    crmCustomerDesc: "Company converted to a paying customer",

    serverHealth: "Server Health",
    systemInformation: "System Information",
    uptime: "Uptime",
    lastCheck: "Last check",
    lastBackup: "Last backup",
    backupSize: "Backup size",
    totalBackups: "Total backups",

    tenantBackupCenter: "Tenant Backup Center",
    latestBackup: "Latest backup",
    latestBackupSize: "Latest backup size",
    totalSize: "Total size",
    healthy: "Healthy",
    empty: "Empty",
    backupRunning: "Backing up...",
    takeBackup: "Create Backup",
    backupHistoryPending: "Backup history API will be connected in the next step",
    restoreFlowPending: "Restore will be added with a secure approval flow",

    userManagement: "User Management",
    allCompanies: "All companies",
    company: "Company",
    role: "Role",
    lastLogin: "Last Login",
    actions: "Actions",
    password: "Password",

    editCompany: "Edit Company",
    addCompany: "Add New Company",
    companyName: "Company Name",
    subdomain: "Subdomain",
    phone: "Phone",
    simulationOption: "🔬 Simulation",
    realMachineOption: "🏭 Real Machine",
    maxUsers: "Max Users",
    cancel: "Cancel",
    save: "Save",

    currency: "Currency",
    statusActive: "Active",
    statusTrial: "Trial",
    statusExpired: "Expired",
    statusCancelled: "Cancelled",
    trialEndDate: "Trial End Date",

    editUser: "Edit User",
    addUser: "Add New User",
    username: "Username",

    roleAdmin: "Admin",
    roleManager: "Manager",
    roleTechnician: "Technician",
    roleOperator: "Operator",
    roleQuality: "Quality",

    select: "Select...",

    confirmManualBackup: "Create a manual backup now?",
    confirmDeleteTenant: "Are you sure you want to delete this company?",
    promptNewPassword: "New password:",
    confirmDeleteUser: "Delete this user?",
    confirmImpersonateTenant: "Sign in to this company account as Super Admin?",
    promptExtendMonths: "Extend by how many months? (1, 3, 6, 12)",

    backupFailed: "Backup could not be created",
    backupCreated: "Backup created ✓",
    backupConnectionError: "Backup connection error",

    licenseUpdated: "License updated ✓",
    licenseUpdateFailed: "License could not be updated",
    licenseConnectionError: "License connection error",

    userCreated: "User created ✓",
    passwordReset: "Password reset ✓",
    userUpdated: "User updated ✓",
    userUpdateFailed: "User could not be updated",
    userDeleted: "User deleted ✓",
    userDeleteFailed: "User could not be deleted",

    tenantLoginError: "Tenant sign-in error",
    genericError: "An error occurred",
    connectionError: "Connection error",
  },

  // Dashboard
  dashboard: {
    factoryOee: "Factory OEE",
    totalProduction: "Total Production",
    activeAlarms: "Active Alarms",
    monthlyLoss: "Monthly Loss",
    machineStatus: "Machine Status",
    lastAlarms: "Recent Alarms",
    oeeDesc: "Overall Equipment Effectiveness",
    productionDesc: "Total produced parts",
    alarmDesc: "Pending alarms",
    lossDesc: "Estimated production loss",

    // Dashboard Final
    refresh: "Refresh",
    refreshing: "Refreshing",
    live: "LIVE",
    waitingForData: "Waiting for data",
    updatedJustNow: "Updated just now",
    secondsAgo: "sec ago",
    refreshTitle: "Refresh dashboard data",
    lightTheme: "Light Theme",
    darkTheme: "Dark Theme",
    switchToLightTheme: "Switch to light theme",
    switchToDarkTheme: "Switch to dark theme",
    viewAll: "View All",
    viewAllArrow: "View All →",

    machine: "Machine",
    oee: "OEE",
    program: "Program",
    progress: "Progress",

    factoryBrain: "Factory Brain",
    noActiveRecommendations: "No active recommendations.",
    viewAllAnalyses: "View All Analyses →",

    profitLoss: "Profit & Loss",
    last30Days: "Last 30 Days",
    totalRevenue: "Revenue",
    totalExpense: "Expense",
    grossProfit: "Gross Profit",
    grossMargin: "Gross Margin",

    time: "Time",
    alarmCode: "Alarm Code",
    description: "Description",
    status: "Status",
    noActiveAlarms: "No active alarms",
    activeMachineAlarm: "Active machine alarm",

    // Sales Dashboard
    salesOrderCount: "ORDER COUNT",
    salesLast30Days: "Last 30 days",
    salesPendingOrders: "PENDING ORDERS",
    salesPendingOrdersDesc: "In planning / production",
    salesWaitingShipment: "AWAITING SHIPMENT",
    salesWaitingShipmentDesc: "Ready / awaiting shipment",
    salesCompleted: "COMPLETED",
    salesCompletedDesc: "Completed / shipped",
    salesInvoicePending: "AWAITING INVOICE",
    salesInvoicePendingDesc: "Awaiting invoicing",
    salesCustomerCount: "CUSTOMER COUNT",
    salesCustomerCountDesc: "Authorized customer scope",
    salesCancelled: "CANCELLED / REJECTED",
    salesCancelledDesc: "Cancelled or rejected",

    recentSalesOrders: "Recent Sales Orders",
    orderNo: "Order No",
    customer: "Customer",
    amount: "Amount",

    topSellingProducts: "Top Selling Products",
    product: "Product",
    quantity: "Quantity",

    // Dashboard Final Freeze
    mainModules: "Main Modules",
    backToSuperAdmin: "Back to Super Admin",
    noNotifications: "No notifications",
    notifications: "Notifications",
    markAllRead: "Mark all as read",

    salesMonthAmount: "SALES THIS MONTH",
    salesMonthAmountDesc: "Authorized sales scope",

    severityHigh: "High",
    severityInfo: "Info",

    moduleSuffix: "module",

    statusRunning: "Running",
    statusFault: "Fault",
    statusStopped: "Stopped",
    statusIdle: "Idle",
    statusOffline: "Offline",
    statusSetup: "Setup",
    statusMaintenance: "Maintenance",
    statusToolChange: "Tool Change",
    statusUnknown: "Unknown",
  },

  // Machine status
  machineStatus: {
    running: "Running",
    fault: "Fault",
    offline: "Offline",
    maintenance: "Maintenance",
    idle: "Idle",
    stopped: "Stopped",
  },

  // Alarm
  alarmLevel: {
    KRITIK: "Critical",
    UYARI: "Warning",
    NORMAL: "Normal",
  },

  // Work Orders
  workorders: {
    title: "Work Orders",
    subtitle: "Production planning · MRP · Capacity · Cost tracking",
    new: "+ New Work Order",
    orderNo: "Order No",
    deadline: "Deadline",
    progress: "Progress",
    startProduction: "🏭 Start Production",
    sourceOrder: "Source Order",
    assignedMachine: "Assign Machine",
    assignedOperator: "Assign Operator",
    noOrders: "No work orders yet.",
    noMatch: "No work orders match the filters.",
    allStatuses: "All Statuses",
    allPriorities: "All Priorities",
    inProduction: "In Production",
    completed: "Completed",
    released: "Released",
    status: {
      draft: "Draft",
      planned: "Planned",
      released: "Released",
      in_progress: "In Progress",
      assembly_pending: "Awaiting Assembly",
      assembly_in_progress: "In Assembly",
      assembly_done: "Assembly Completed",
      completed: "Completed",
      closed: "Closed",
      cancelled: "Cancelled",
    },
    priority: {
      low: "Low",
      normal: "Normal",
      high: "High",
      urgent: "Urgent",
      critical: "Critical",
    },
    tabs: {
      overview: "📋 General",
      production: "🏭 Operation",
      materials: "📋 Bill of Materials",
      revisions: "🔁 Revisions",
      audit: "📜 History",
    },
    plannedQty: "Planned Quantity",
    producedQty: "Produced Quantity",
    createdBy: "Created By",
    completion: "Completion",
    materialCheck: "Material Check",
    sufficient: "Sufficient",
    insufficient: "Insufficient",
    noBom: "No BOM defined or material info not found for this product.",
    materialNeeded: "Required",
    materialAvailable: "Available",
    purchaseCreated: "Purchase Requests Created",
    purchaseInfo: "Requests have been sent to the Purchasing department.",
    noManagerPermission: "Production manager role required to start production.",
    alreadyInProduction: "This work order is already in production.",
    materialInfo: "System will check materials when you click Start Production.",
    // Cost
    stdCost: "Standard Cost",
    actCost: "Actual Cost",
    variance: "Variance",
    saving: "Saving",
    overrun: "Overrun",
    stdVsAct: "Standard vs Actual Comparison",
    item: "Item",
    standard: "Standard",
    actual: "Actual",
    statusLabel: "Status",
    material: "Material",
    labor: "Labor",
    overhead: "Overhead",
    scrap: "Scrap",
    loss: "Loss",
    notEntered: "Not entered",
    total: "TOTAL",
    actCostEntry: "Actual Cost Entry",
    costSaved: "Actual costs saved",
    totalActual: "Total actual",
    // Form
    editOrder: "Edit Work Order",
    productionType: "Production Type",
    prodForCustomer: "Production for Order",
    prodForCustomerDesc: "For a customer order",
    prodForStock: "Production for Stock",
    prodForStockDesc: "For factory warehouse",
    customerL: "Customer",
    customerName: "Customer Name",
    searchCustomer: "Search customer...",
    stockOrderNo: "Stock Order No",
    stockOrderNote: "Produced items will be added to factory warehouse.",
    product_: "Product",
    productName: "Product Name",
    productCode: "Product Code",
    searchProduct: "Search product...",
    stock_: "Stock",
    mrpCalc: "Calculating MRP...",
    mrpCostSummary: "MRP / Cost Summary",
    rawMaterial: "Raw Material",
    outsource: "Outsource",
    laborSgk: "Labor+SSI",
    unitCost: "Unit Cost",
    mrpShortage: "Material shortage! Purchase required before production.",
    rawMaterialStatus: "Raw Material Status",
    needed: "Required",
    inWarehouse: "In warehouse",
    outsourceOps: "Outsource Operations",
    totalCostFor: "Total cost",
    qty: "Quantity",
    unit_: "Unit",
    pcs: "Pcs",
    productionPlan: "Production Plan",
    start: "Start",
    deadlineWorkdays: "Deadline (working days)",
    deadlineDate: "Deadline Date",
    machine_: "Machine",
    machineIdPlaceholder: "Machine ID",
    operatorKiosk: "Operator (Kiosk)",
    selectOperator: "Select Operator",
    priority_: "Priority",
    notes_: "Notes",
    cancel_: "Cancel",
    saving_: "Saving...",
    update_: "Update",
    create_: "Create",
    // Detail
    orderInfo: "Work Order Info",
    productionStatus: "Production Status",
    salesQty: "Sales Order Quantity",
    sourceOrder_: "Source Order",
    operator_: "Operator",
    edit: "Edit",
    cancelOrder: "Cancel",
    cancelConfirm: "Are you sure you want to cancel this work order?",
    cancelInProgressNote: "Unshipped produced items will be added to factory stock.",
    createDepotOrder: "Create depot stock order (DPO) for remaining quantity",
    cancelReasonPlaceholder: "Enter cancellation reason... (required)",
    yesCancelIt: "Yes, Cancel It",
    goBack: "Go Back",
    cancelReasonRequired: "Cancellation reason is required.",
    cancelFailed: "Cancellation failed.",
    cancelled_: "Work order cancelled.",
    cancelledWithStock: "Work order cancelled. {n} pcs were added to factory stock.",
    assignMachineOp: "Assign Machine & Operator",
    select: "Select...",
    processing: "Processing...",
    okClose: "OK, Close",
    shortage_: "Shortage",
    requestNo: "Request No",
    available_: "Available",
    cost: "Cost",
    // Main list
    statTotal: "Total",
    refresh: "Refresh",
    searchPlaceholder: "Search order no, product or customer...",
    orderCount: "work orders",
    loading_: "Loading...",
    retry: "Retry",
    errFetch: "Could not load work orders",
    errGeneric: "An error occurred",
    connectionError: "Connection error",
    approveOrderConfirm: "work order — approve?",
    approveFailed: "Approval failed",
    orderApproved: "Work order approved.",
    approveError: "An error occurred during approval.",
    rejectOrderPrompt: "work order — why is it being rejected?",
    rejectFailed: "Rejection failed",
    orderRejected: "Work order rejected.",
    rejectError: "An error occurred during rejection.",
    treeLoadFailed: "Could not load work order tree",

    downtimeReasonLabel: "Downtime reason",
    durationLabel: "Duration",
    selectDowntimeReason: "Select Downtime Reason",
    downtimeDurationLabel: "Downtime duration",

    // Runtime / production action messages
    runtimeStatusLoadFailed: "Could not load runtime status.",
    downtimeReasonsLoadFailed: "Could not load downtime reasons.",
    activeDowntimeLoadFailed: "Could not load active downtime information.",
    downtimeDescriptionLabel: "Description",
    downtimeNoteRequired: "A description is required for this downtime reason.",
    downtimeReasonSaveFailed: "Could not save the downtime reason.",
    assignedMachineNotFound: "No machine is assigned to this work order.",
    runtimeStartConfirm: "A production runtime record will be started for this work order.\n\nThis action does not physically start the CNC machine.",
    runtimeStartFailed: "Could not start the production runtime record.",
    materialShortageProductionBlocked: "Materials are missing. Production cannot start until the required materials are available.",

    // Materials / revisions / audit / actions
    revisionEmpty: "No revision records found.",
    auditActionWorkOrderUpdated: "Work Order Updated",
    auditDescriptionWorkOrderUpdated: "Work order information was updated",
    auditEmpty: "No history records found.",
    revisionQuantity: "Quantity",
    revisionDeadline: "Deadline",
    revisionPriority: "Priority",
    revisionReason: "Reason",
    treeAction: "Tree",
    detailAction: "Detail",
    treeTitle: "Work Order Tree",
    treeLoading: "Loading tree...",
    treeNoData: "No tree data found.",
    approval: "Approval",
    approvalApproved: "Approved",
    approvalRejected: "Rejected",
    approvalPending: "Pending",
    dependencyReady: "Ready",
    dependencyWaitingChildren: "Waiting for child work orders",
    dependencyBlocked: "Blocked",
    dependencyPending: "Pending",
    internalQc: "In-Process QC",
    finalQcWaiting: "Final QC Pending",
    treeProductFallback: "Product",
    recordUnit: "records",
    errProductQtyRequired: "Product name and quantity are required.",
    detail_: "Detail",
    actions_: "Actions",
    createdAt: "Created",
    save: "Save",
    error: "Error",
    prodQty: "Production Quantity",

    // Runtime / live production
    runtimeReady: "🟦 Ready",
    runtimePaused: "⏸ Paused",
    runtimeNotFound: "— Runtime not found",
    machineRealStatus: "Actual Machine Status",
    machineNoConnection: "⚫ No connection",
    machineRunningLive: "🟢 Machine running",
    machineStoppedLive: "🟡 Machine stopped",
    machineDowntimeDetected: "⚠️ Machine downtime detected",
    downtimePlanned: "Planned downtime",
    downtimeUnplanned: "Unplanned downtime",
    downtimeDescriptionRequired: " · Description required",
    downtimeReasonsLoading: "Loading downtime reasons...",
    noDowntimeReason: "No downtime reason found.",
    downtimeDescriptionPlaceholder: "Enter a short description if needed...",
    startingProduction: "Starting...",
    startRuntimeProduction: "▶ Start Production",
    startProductionFirst: "Start production first.",
    cannotCompleteMachineOffline: "Production cannot be completed while the machine is offline.",
    cannotCompleteMachineRunning: "Production cannot be completed while the machine is running.",
    startProductionFirstButton: "▶ Start Production First",
    machineConnectionMissingButton: "⚫ Machine Connection Lost",
    stopMachineFirstButton: "⛔ Stop Machine First",
    completeRuntimeProduction: "✅ Complete Production",
    whyMachineStopped: "Why Did the Machine Stop?",
    machineStatusLabel: "Machine status:",
    downtimeOperator: "Operator",

    // Runtime screen final localization
    mesStatus: "MES Status",
    checkingStatus: "Checking...",
    runtimeActive: "▶ Active",
    machineStatusUnknown: "⚪ Status unknown",
    runtimeMachineWaitingWarning: "⚠️ MES production is active, but the machine is not running yet. After completing the safety checks on the CNC panel, the operator must press Cycle Start.",
    downtimeReasonInfo: "This selection does not start or stop the CNC machine. It only records the reason for the actual downtime.",
    checkStatus: "🔄 Check Status",
    producedQuantity: "Produced Quantity",

},

  // Sales Orders (kısa — menu/badge için)
  salesorders: {
    title: "Sales Orders",
    subtitle: "Customer orders · Approval flow · Production tracking",
    new: "+ New Order",
    orderNo: "Order No",
    itemCount: "Item Count",
    delivery: "Delivery Date",
    createdBy: "Created By",
    domestic: "Domestic",
    foreign: "Foreign/Export",
    startProduction: "🏭 Start Production",
    approve: "✅ Approve",
    reject: "✗ Reject",
    cancel: "🗑️ Cancel",
    draft: "Draft",
    inProduction: "In Production",
    readyToShip: "Ready to Ship",
    completedOrders: "Completed",
    noOrders: "No orders yet. Create a new order.",
    noMatch: "No matching orders found.",
    allStatuses: "All Statuses",
    status: {
      draft: "Draft",
      pending_approval: "Pending Approval",
      approved: "Approved",
      rejected: "Rejected",
      in_production: "In Production",
      ready: "Ready to Ship",
      shipped: "Shipped",
      completed: "Completed",
      cancelled: "Cancelled",
    },
  },

  // Sales Orders — SalesOrders.js için genişletilmiş blok
  salesOrders: {
    title: "Sales Orders",
    subtitle: "Customer orders · Approval flow · Production tracking",
    newOrder: "New Order",
    editOrder: "Edit Order",
    newCustomer: "New Customer",
    addNewCustomer: "Add New Customer",
    saveCustomer: "Save Customer",
    customerInfo: "Customer / Account Info",
    customerName: "Customer / Company Name",
    customerType: "Type",
    searchCustomer: "Search Customer",
    customerSearchPlaceholder: "Customer name or code...",
    customer: "Customer",
    domestic: "Domestic",
    foreign: "Foreign",
    city: "City",
    phone: "Phone",
    email: "Email",
    assignedSalesRep: "Assigned Sales Rep",
    unassigned: "Unassigned",
    orderDate: "Order Date",
    deliveryDate: "Delivery Date",
    notes: "Notes",
    orderItems: "Order Items",
    addItem: "Add Item",
    item: "Item",
    productName: "Product Name",
    searchProduct: "Search product...",
    selectFromListWarning: "Please select a product from the list",
    available: "Available",
    noStock: "No Stock — Production Required",
    allReserved: "In warehouse but all reserved",
    total: "Total",
    totalLabel: "total",
    reserved: "Reserved",
    quantity: "Quantity",
    unit: "Unit",
    unitPcs: "Pcs",
    unitPrice: "Unit Price",
    selected: "Selected",
    close: "Close",
    cancel: "Cancel",
    saving: "Saving...",
    create: "Create",
    saveOrder: "Save Order",
    update: "Update",
    edit: "Edit",
    approve: "Approve",
    reject: "Reject",
    startProduction: "Start Production",
    processing: "Processing...",
    detail: "Detail",
    orderInfo: "Order Information",
    orderNo: "Order No",
    createdBy: "Created By",
    approvedBy: "Approved By",
    productionStatus: "Production Status",
    totalItems: "Total Items",
    inProduction: "In Production",
    inProductionLabel: "in production",
    qcPassed: "QC Passed",
    qcShort: "QC",
    waiting: "Waiting",
    waitingLabel: "waiting",
    qcCompletion: "QC Completion",
    qcPass: "Passed",
    qcPartial: "Partial",
    qcFail: "Failed",
    passed: "passed",
    scrap: "scrap",
    rejectionReason: "Rejection Reason",
    rejectionPlaceholder: "Why was it rejected?",
    rejectionReasonLabel: "Rejection reason",
    loading: "Loading...",
    detailError: "Could not load detail",
    invoiceHistory: "Invoice History",
    invoiceAndShipping: "Invoice & Shipping Info",
    invoiced: "Invoiced",
    invoiceNo: "Invoice No",
    invoiceDate: "Invoice Date",
    newInvoice: "New Invoice",
    deliveryNoteNo: "Delivery Note No",
    cargoCompany: "Cargo Company",
    cargoPlaceholder: "DHL, FedEx...",
    trackingNo: "Tracking No",
    trackingPlaceholder: "Cargo tracking number",
    tracking: "Tracking",
    date: "Date",
    amount: "Amount",
    issuedBy: "Issued By",
    invoiceWarning: "Shipment cannot be made without an invoice. Please enter invoice details.",
    markAsInvoiced: "Mark as Invoiced",
    customerConfirmed: "Customer confirmed delivery",
    customerDelivered: "Customer Delivered",
    product: "Product",
    code: "Code",
    workOrder: "Work Order",
    machine: "Machine",
    operator: "Operator",
    status: "Status",
    action: "Action",
    shipping: "Shipping",
    shipped: "shipped",
    readyToShip: "ready to ship",
    remaining: "remaining",
    missingShipment: "Incomplete shipment!",
    itemCount: "Item Count",
    productionPlanResult: "Production Plan Result",
    allFromStock: "All items available in warehouse — Order ready for shipment!",
    fromStock: "From Stock",
    mixed: "Mixed",
    ok: "OK",
    searchPlaceholder: "Search order no or customer...",
    allStatuses: "All Statuses",
    noOrders: "No orders yet.",
    noMatch: "No matching orders found.",
    orderCount: "orders",
    statTotal: "Total",
    alreadyInList: "is already in the list.",
    confirmCancel: "Are you sure you want to cancel this order?",
    cancelReasonPrompt: "Cancellation reason (optional):",
    cancelled: "Cancelled",
    errCustomerNameRequired: "Customer name is required.",
    errSelectCustomer: "Please select a customer.",
    errSelectFromList: "Please select a product from the list for all items.",
    errAllFieldsRequired: "Product name and quantity are required for all items.",
    errDuplicateProduct: "The same product appears in multiple items.",
    errInvoiceNoRequired: "Invoice number is required.",
    errGeneric: "Error",
    errOrdersFetch: "Could not load orders",
    errConnection: "Connection error",
    statusDraft: "Draft",
    statusPendingApproval: "Pending Approval",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    statusInProduction: "In Production",
    statusReady: "Ready to Ship",
    statusShipped: "Shipped",
    statusCompleted: "Completed",
    statusClosed: "Closed",
    orderItemCount: "Order Items",
    orderQuantity: "Order Quantity",
    qcPassedQty: "QC Passed",
    waitingQty: "Waiting",
    salesRep: "Sales Representative",
    salesRegion: "Region",
    statusCancelled: "Cancelled",
    statusPartialShipped: "Partial Shipment",
    statusQcPending: "Final QC Pending",
    statusQcPassed: "QC Passed",
    statusAssemblyPending: "Assembly Pending",
    statusAssemblyInProgress: "In Assembly",
    statusAssemblyDone: "Assembly Completed",
    exportRegion: "Export",
    domesticRegion: "Domestic",
    recordUnit: "records",
    dayShift: "Day Shift",
    errOrderIdMissing: "Order ID was not found. Please refresh the page and try again.",
    submitForApproval: "Submit for Approval",
    adminApprovalPending: "Waiting for Admin Approval",
    approvalByUser: "{user} approved",
  },

  // Stock
  stock: {
    title: "Stock Management",
    materialName: "Material Name",
    currentStock: "Current Stock",
    minStock: "Min. Stock",
    unitPrice: "Unit Price",
    totalValue: "Total Value",
    status: {
      sufficient: "Sufficient",
      low: "Low",
      critical: "Critical",
      empty: "Empty",
    },
  },

  // Quality
  quality: {
    title: "Quality Control & Shipment",
    orderNo: "Work Order No",
    checked: "Checked",
    passed: "Passed",
    failed: "Failed",
    passRate: "Pass Rate",
    inspector: "Inspector",
    status: {
      passed: "✅ Passed",
      failed: "✗ Failed",
      partial: "⚠ Partial",
      pending: "Pending",
    },
  },

  // Maintenance
  maintenance: {
    title: "Maintenance & Service",
    type: "Type",
    technician: "Technician",
    scheduledDate: "Scheduled Date",
    duration: "Duration (min)",
    status: {
      pending: "Pending",
      in_progress: "In Progress",
      completed: "Completed",
      cancelled: "Cancelled",
    },
  },

  // Energy
  energy: {
    title: "Energy Tracking",
    todayKwh: "Today (kWh)",
    todayCost: "Today Cost",
    monthKwh: "This Month (kWh)",
    monthCost: "This Month Cost",
    currentPower: "Current Power (kW)",
    co2: "CO₂ Emission",
  },

  // HR
  hr: {
    title: "HR & Payroll",
subtitle: "Employee management · Attendance tracking · Payroll calculation",
refresh: "Refresh",
    employee: "Employee",
    grossSalary: "Gross Salary",
    netSalary: "Net Salary",
    workDays: "Work Days",
    overtime: "Overtime",
    sgk: "Social Security",
    tax: "Income Tax",

    status: {
      present: "Present",
      absent: "Absent",
      late: "Late",
      leave: "On Leave",
    },

    employeeStatus: {
      active: "Active",
      inactive: "Inactive",
      leave: "On Leave",
      terminated: "Terminated",
    },

    attendanceStatus: {
      present: "Present",
      absent: "Absent",
      late: "Late",
      leave: "On Leave",
      holiday: "Holiday",
    },

    leaveTypes: {
      annual: "Annual Leave",
      sick: "Sick Leave",
      maternity: "Maternity Leave",
      unpaid: "Unpaid Leave",
      excused: "Excused Leave",
    },

    tabs: {
      profile: "Profile",
      attendance: "Attendance",
      leaves: "Leaves",
      payslips: "Payroll",
    },

    // HR Localization RC1.4C.1
    addEmployee: "Add Employee",
    totalEmployees: "Total Employees",
    activeEmployees: "Active",
    presentToday: "Present Today",
    onLeaveEmployees: "On Leave",
    monthlyPayroll: "Monthly Payroll",

    mainTabs: {
      employees: "👤 Employees",
      attendance: "📋 Attendance",
      payroll: "💰 Payroll",
      competency: "🎯 Competency Matrix",
      training: "📚 Training",
      performance: "⭐ Performance",
      orgchart: "🏗️ Org Chart",
      worksettings: "⚙️ Work Settings",
      timesheet: "📊 Timesheet",
      autopayroll: "🧮 Automatic Payroll",
    },

    loading: "Loading...",
    retry: "Retry",
    employeeSearchPlaceholder: "🔍 Search by name, surname or employee no...",
    allDepartments: "All Departments",
    allStatuses: "All Statuses",
    noEmployees: "No employee records yet.",
    noMatchingEmployees: "No matching employees found.",
    noEmployeeData: "No employee data found",

    departments: {
      production: "Production",
      quality: "Quality",
      maintenance: "Maintenance",
      planning: "Planning",
      warehouse: "Warehouse",
      purchasing: "Purchasing",
      hr: "HR",
      accounting: "Accounting",
      management: "Management",
      foreignTrade: "Foreign Trade",
      domesticSales: "Domestic Sales",
    },

    roles: {
      operator: "Operator",
      technician: "Technician",
      warehouse: "Warehouse",
      manager: "Manager",
      admin: "Admin",
      quality: "Quality",
      planner: "Planning",
      maintenance: "Maintenance",
    },

    titles: {
      cncOperator: "CNC Operator",
      qualityEngineer: "Quality Engineer",
      productionPlanning: "Production Planning",
      maintenanceTechnician: "Maintenance Technician",
      domesticSalesManager: "Domestic Sales Manager",
      domesticSalesRepresentative: "Domestic Sales Representative",
      domesticSalesSpecialist: "Domestic Sales Specialist",
    },

    shifts: {
      day: "Day",
      evening: "Evening",
      night: "Night",
    },

    // Shift Planning Localization RC1.6B2
    shiftsUi: {
      title: "Shift Planning",
      subtitle: "Weekly planning · Personnel assignment · Attendance tracking",
      refresh: "Refresh",

      assignShiftTitle: "📅 Assign Shift",
      assignShift: "Assign Shift",
      saving: "Saving...",
      saveError: "Shift could not be saved.",
      personnelMachineRequired: "Personnel and machine are required.",

      totalAssignments: "Total Assignments",
      planned: "Planned",
      completed: "Completed",
      activePersonnel: "Active Personnel",

      weeklyCalendar: "Weekly Calendar",
      shiftList: "Shift List",
      attendanceTracking: "Attendance",

      previous: "Previous",
      next: "Next",
      today: "Today",

      personnel: "Personnel",
      role: "Role",
      machine: "Machine",
      shift: "Shift",
      date: "Date",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Status",
      action: "Action",
      workedHours: "Worked Hours",
      overtime: "Overtime",

      noPersonnel: "No personnel found",
      noAssignments: "No shift assignments found",
      noAttendance: "No attendance records found",

      statusCompleted: "✓ Completed",
      statusPlanned: "⏳ Planned",
      delete: "Delete",
    },

    // HR Localization RC1.4C.2 — Employee Form
    // HR Localization RC1.4C.3 — Detail / List
    // HR Localization RC1.4D.1 — Attendance / Timesheet
    attendanceUi: {
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      viewTimesheet: "📊 View Timesheet",
      addAttendance: "+ Add Attendance Record",
      markMissingAbsent: "⚠️ Mark Missing as Absent",
      selectMonthHint: "Select a month above and click View Timesheet.",
      loading: "Loading...",
      personnel: "Employee",
      workDays: "Work Days",
      hours: "Hours",
      overtime: "Overtime",
      date: "Date",
      checkInTime: "Check-in Time",
      cancel: "Cancel",
      checkOutTime: "Check-out Time",
      status: "Status",
      save: "Save",
      saving: "Saving...",
      statusPresent: "Present",
      statusAbsent: "Absent",
      statusLate: "Late",
      statusLeave: "On Leave",
      statusHoliday: "Holiday",
    },

    // HR Localization RC1.4E.1 — Payroll / AutoPayroll
    payrollUi: {
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],

      calculatePayroll: "🧮 Calculate Payroll",
      savePayroll: "💾 Save Payroll",
      saving: "Saving...",
      calculating: "Calculating...",
      selectMonthHint: "Select a month and click Calculate Payroll.",

      payrollInfo: "ℹ️ Payroll calculation is based on timesheet records. Enter attendance records from the Timesheet tab first.",
      payrollRatesInfo: "Social security rates: Employee 14%, Employer 20.75% | Stamp Tax 0.759% | Overtime 1.5x (configurable in Work Settings).",

      totalGross: "Total Gross",
      totalNet: "Total Net",
      totalEmployerCost: "Total Employer Cost",
      totalEmployerSgk: "Total Employer Social Security",
      totalEmployeeSgk: "Total Employee Social Security",
      estimatedTotalNet: "Estimated Total Net",

      personnel: "Employee",
      departmentShort: "Dept",
      workDays: "Work Days",
      absent: "Absent",
      workHoursShort: "Work Hrs.",
      overtimeHoursShort: "OT Hrs.",
      gross: "Gross",
      absenceDeductionShort: "Absence Ded.",
      employeeSgk: "Employee SS",
      unemployment: "Unemployment",
      incomeTaxShort: "Income Tax",
      stampTaxShort: "Stamp Tax",
      net: "Net",
      employerSgk: "Employer SS",

      monthlyPayrollList: "💰 Monthly Payroll List",
      estimatedCalculationNote: "*Estimated calculation (14% social security, 15% income tax)",

      employee: "Employee",
      department: "Department",
      grossSalary: "Gross Salary",
      employeeSgkRate: "Employee Social Security (14%)",
      incomeTaxRate: "Income Tax (15%)",
      netSalary: "Net Salary",
      employerSgkRate: "Employer Social Security (20.75%)",

      disclaimer: "ℹ️ Payroll calculations are estimates. Coordinate with the accounting department for official payroll.",
      legislationNote: "Social security premiums and tax brackets may vary according to legislation.",
    },

    // HR Localization RC1.4F.1 — Competency / Training
    competencyUi: {
      intro: "🎯 Who can operate which machine or equipment? Certification status and competency levels are managed here.",
      employee: "Employee",
      noActiveEmployee: "No active employees found",

      levels: {
        master: "Master",
        basic: "Basic",
        trainee: "Trainee",
        expired: "Expired",
        none: "None",
      },

      levelDescriptions: {
        master: "Can work independently and provide training",
        basic: "Can work under supervision",
        trainee: "Currently in training",
        expired: "Certification must be renewed",
        none: "No competency assigned",
      },

      expiredDisplay: "⚠️ Expired",

      skills: {
        cnc: "CNC Machine",
        lathe: "Lathe",
        milling: "Milling",
        welding: "Welding",
        forklift: "Forklift",
        crane: "Crane",
        press: "Press",
        qualityEquipment: "Quality Equipment",
      },
    },

    trainingUi: {
      trainingUnit: "training",
      completed: "Completed",
      expiredWarning: "⚠️ There are expired certificates! Direct the relevant employees to training.",
      plannedTraining: "Planned Training",
      participant: "Participant",
      expiredCertificate: "Expired Certificate",

      planTitle: "📚 Training Plan",
      addTraining: "+ Add Training",

      categories: {
        safety: "Occupational Safety",
        technical: "Technical Training",
        quality: "Quality Training",
        machine: "Machine Operation",
        management: "Management Training",
        other: "Other",
      },

      emptyPlan: "📚 No training plan has been created yet.",
      backendTrainingNote: "Data will appear here once the /hr/trainings endpoint is added to the backend.",

      certificateTracking: "🏆 Certificate Tracking",
      employee: "Employee",
      department: "Department",
      certificate: "Certificate",
      issueDate: "Issue Date",
      validity: "Validity",
      status: "Status",
      noCertificate: "No certificate records found. They will appear once the /hr/certificates endpoint is added.",
    },

    // HR Localization RC1.4F.2 — Performance / Work Settings
    performanceUi: {
      overallScore: "Overall Score",
      noActiveEmployee: "No active employees found",
      evaluationCriteria: "📊 Evaluation Criteria",
      intro: "⭐ Employee performance evaluation — integrated with OEE data, target tracking and annual reviews.",
      attendance: "Attendance",
      productivity: "Productivity",
      quality: "Quality",

      criteria: {
        attendance: "Attendance & Punctuality",
        attendanceDesc: "Attendance rate and number of late arrivals",
        productivity: "Productivity",
        productivityDesc: "OEE data and target achievement rate",
        quality: "Quality",
        qualityDesc: "Defect rate and number of reworks",
      },
    },

    orgChartUi: {
      title: "🏗️ Organization Chart",
      departmentDistribution: "📊 Department Distribution",
    },

    workSettingsUi: {
      workHoursTitle: "🕐 Working Hours",
      workStart: "Work Start",
      workEnd: "Work End",
      normalWorkPrefix: "ℹ️ Normal working hours:",
      normalWorkBetween: ".",
      total: "Total:",
      hourUnit: "hours.",

      breakSettings: "☕ Break Settings",
      lunchBreak: "Lunch Break (minutes)",
      teaBreak: "Tea/Short Break Total (minutes)",
      totalBreak: "⚠️ Total break:",
      minuteUnit: "minutes.",
      breakDeductionInfo: "These periods are deducted when calculating net working hours.",

      overtimeSettings: "⏰ Overtime & Weekend Multipliers",
      overtimeMultiplier: "Overtime Multiplier",
      overtimeMultiplierDesc: "Multiple of the normal wage",
      saturdayMultiplier: "Saturday Multiplier",
      saturdayMultiplierDesc: "Saturday work multiplier",
      sundayMultiplier: "Sunday Multiplier",
      sundayMultiplierDesc: "Sunday work multiplier",

      workDaysLeave: "📅 Working Days & Leave",
      workDays: "Working Days",
      annualLeaveDays: "Annual Leave Allowance (days)",

      days: {
        Mon: "Mon",
        Tue: "Tue",
        Wed: "Wed",
        Thu: "Thu",
        Fri: "Fri",
        Sat: "Sat",
        Sun: "Sun",
      },

      saved: "✅ Settings saved!",
      saving: "Saving...",
      save: "💾 Save Settings",
    },

    // HR Localization RC1.4G — Final visible polish
    finalUi: {
      personalInfo: "👤 Personal Information",
      emergencyContact: "Emergency Contact",
      workInfo: "💼 Work Information",
      role: "Role",
      hireDate: "Hire Date",
      seniorityYears: "Seniority (Years)",
      notes: "Notes",
      select: "Select...",

      shortAttendance: {
        present: "P",
        absent: "A",
        late: "Late",
        leave: "L",
        holiday: "H",
      },
    },

    employeeDetail: {
      birthDate: "Date of Birth",
      phone: "Phone",
      email: "Email",
      employeeNo: "Employee No",
      department: "Department",
      position: "Position",
      shift: "Shift",
      manager: "Manager",

      last30DaysSummary: "📊 Last 30 Days Summary",
      last30Days: "Last 30 Days",
      attendance: "Attendance",
      day: "Days",
      late: "Late",
      absent: "Absent",

      date: "Date",
      checkIn: "Check In",
      checkOut: "Check Out",
      workingHours: "Working Hours",
      status: "Status",
      noAttendance: "No attendance records found",

      annualLeaveAllowance: "Annual Leave Allowance",
      usedLeave: "Used",
      dayUnit: "days",
      noLeave: "No leave records found",

      leaveApproved: "Approved",
      leavePending: "Pending",
      leaveRejected: "Rejected",

      noPayslip: "No payroll records found",
      payslipSuffix: "Payslip",
      grossSalary: "Gross Salary",
      socialSecurityEmployee: "Employee Social Security",
      netSalary: "Net Salary",

      seniority: "Seniority",
      yearShort: "y",

      employee: "Employee",
      hireDate: "Hire Date",
      action: "Action",
      noEmployee: "No employees found",

      todayAttendance: "📋 Today's Attendance",
    },

    employeeForm: {
      addTitle: "➕ New Employee",
      editTitle: "✏️ Edit Employee",
      department: "Department",
      positionTitle: "Position / Title",
      role: "Role",
      status: "Status",
      shift: "Shift",
      hireDate: "Hire Date",
      birthDate: "Date of Birth",
      grossSalary: "Gross Salary (₺)",
      annualLeaveDays: "Annual Leave (days)",
      manager: "Manager",
      emergencyContact: "Emergency Contact",
      cancel: "Cancel",
      saving: "Saving...",
      update: "Update",
      add: "Add",
      employeeLoadFailed: "Could not load employee data",
      fullName: "Full Name *",
      employeeNo: "Employee No",
      nationalId: "National ID No",
      email: "Email",
      phone: "Phone",
      address: "Address",
      requiredNameDepartment: "Full name and department are required.",
      genericError: "Error",
    },
  },

  // Kaizen
  kaizen: {
    title: "Kaizen & Improvement",
    suggestion: "Suggestion",
    problem: "Problem",
    solution: "Solution",
    estimatedSaving: "Estimated Saving",
    actualSaving: "Actual Saving",
    status: {
      idea: "Idea",
      reviewing: "Reviewing",
      implementing: "Implementing",
      completed: "Completed",
      rejected: "Rejected",
    },
  },

  // Reports
  reports: {
    title: "Reports",
    production: "Production Report",
    quality: "Quality Report",
    maintenance: "Maintenance Report",
    energy: "Energy Report",
    stock: "Stock Report",
    financial: "Financial Report",
    hr: "HR Report",
    kaizen: "Kaizen Report",
    startDate: "Start Date",
    endDate: "End Date",
    download: "📥 Download PDF",
    generate: "Generate Report",

    // Reports Localization RC1
    tabDashboard: "📊 Management Dashboard",
    tabScrap: "🔥 Scrap Report",

    // Reports Localization RC1.1C - Fire Report
    fireAnalysisTitle: "🔥 Scrap / Waste Analysis",
    fireAnalysisDesc: "Scrap records for the last 30 days",
    fireRefresh: "🔄 Refresh",
    fireLoading: "Loading...",
    fireLoadFailed: "Failed to load data",

    fireAvgRate: "Average Scrap Rate",
    fireTotalFailed: "Total Scrap Quantity",
    fireTotalProduced: "Total Produced",
    fireAffectedProducts: "Affected Products",
    fireUnitPieces: "pcs",
    fireUnitTypes: "types",

    fireTabOverview: "📊 Overview",
    fireTabRecords: "📋 Records",
    fireTabTrend: "📈 Trend",

    fireByProduct: "📦 Scrap Rate by Product",
    fireByCustomer: "👤 Scrap by Customer",

    fireColProductCode: "Product Code",
    fireColProductName: "Product Name",
    fireColProduct: "Product",
    fireColCustomer: "Customer",
    fireColPlanned: "Planned",
    fireColScrap: "Scrap",
    fireColRate: "Rate",

    fireNoData: "No data",
    numberLocale: "en-US",

    // Reports Localization RC1.1D
    fireDailyQty: "📈 Daily Scrap Quantity",
    fireDailyRate: "📉 Daily Scrap Rate %",
    fireQty: "Scrap Quantity",
    fireRateLabel: "Scrap Rate",
    firePercent: "Scrap %",

    selectReportHint: "💡 Select a report type to generate a report.",
    view: "View",

    reportCreateFailed: "Failed to generate report",
    startDateLabel: "Start Date",
    endDateLabel: "End Date",

    customerType: "Customer Type",
    customerAll: "🌍 All",
    customerDomestic: "🏠 Domestic",
    customerForeign: "✈️ International",

    reportScope: "Report Scope",
    scopeAllPersonnel: "👥 All Personnel",
    scopeDepartment: "🏢 Department",
    scopeSinglePersonnel: "👤 Single Employee",

    department: "Department",
    employeeName: "Employee Name",
    selectDepartment: "— Select department —",
    employeePlaceholder: "Enter employee name...",
    selected: "✓ Selected",

    outputFormat: "Output Format",
    includeCharts: "📈 Include charts",
    includeDetails: "📋 Include detail tables",
    sendEmail: "📧 Send by email",
    emailAddress: "Email Address",

    cancel: "Cancel",
    generating: "Generating...",
    generateReport: "Generate Report",

    // Report Types RC1.1D
    reportTypeProduction: "Production Report",
    reportTypeProductionDesc: "OEE, production quantity, machine performance",
    reportTypeQuality: "Quality Report",
    reportTypeQualityDesc: "Pass rate, scrap, quality trends",
    reportTypeFire: "Scrap / Waste Report",
    reportTypeFireDesc: "Scrap records, product-based scrap rate, cost",
    reportTypeMaintenance: "Maintenance Report",
    reportTypeMaintenanceDesc: "MTBF, MTTR, maintenance costs",
    reportTypeEnergy: "Energy Report",
    reportTypeEnergyDesc: "Consumption, cost, CO₂ emissions",
    reportTypeStock: "Stock Report",
    reportTypeStockDesc: "Stock movements, critical levels, value",
    reportTypeFinancial: "Financial Summary",
    reportTypeFinancialDesc: "Revenue, expenses, production cost summary",
    reportTypeHr: "HR Report",
    reportTypeHrDesc: "Attendance, leave, payroll summary",
    reportTypeKaizen: "Kaizen Report",
    reportTypeKaizenDesc: "Improvement suggestions, savings, 5S",
    reportTypeNcr: "NCR & CAPA Report",
    reportTypeNcrDesc: "NCR count, cost, decision distribution, CAPA summary",
    reportTypeSales: "Sales Orders Report",
    reportTypeSalesDesc: "Order status, shipment summary, customer-based analysis",
    reportTypeSalesPersonnel: "Sales Personnel Report",
    reportTypeSalesPersonnelDesc: "Revenue by personnel, domestic/international comparison, period analysis",
    reportTypePersonnelAll: "Personnel & HR Report",
    reportTypePersonnelAllDesc: "All departments, overtime, attendance, payroll summary",
    // PersonnelReport Localization RC1.1F
    personnelReportTotalPersonnel: "Total Personnel",
    personnelReportActivePersonnel: "Active Personnel",
    personnelReportTotalAbsence: "Total Absence",
    personnelReportTotalOvertime: "Total Overtime",
    personnelReportAllSuffix: "All",
    personnelReportPersonUnit: "people",
    personnelReportSearchPlaceholder: "🔍 Search personnel...",
    personnelReportAllDepartments: "🏢 All Departments",
    personnelReportListTitle: "👥 Personnel List",
    personnelReportDetailHint: "Click 👤 Detail for individual PDF/Excel",
    personnelReportNotFound: "No personnel found",
    personnelReportColumnPersonnel: "Personnel",
    personnelReportColumnDepartment: "Department",
    personnelReportColumnTitle: "Title",
    personnelReportColumnStatus: "Status",
    personnelReportColumnHireDate: "Hire Date",
    personnelReportColumnShift: "Shift",
    personnelReportActive: "✅ Active",
    personnelReportPassive: "⏸ Inactive",
    personnelReportDetail: "👤 Detail",
    personnelReportLoading: "Loading data...",
    personnelReportTotalWork: "Total Work",
    personnelReportAbsence: "Absence",
    personnelReportLeaveDays: "Leave Days",
    personnelReportOvertimeHours: "Overtime (Hours)",
    personnelReportGrossSalary: "Gross Salary",
    personnelReportNetSalary: "Net Salary",
    personnelReportDayUnit: "days",
    personnelReportHourUnit: "hrs",
    personnelReportPayrollBreakdown: "💰 Payroll Breakdown",
    personnelReportSgkEmployee: "Employee SSI (%14)",
    personnelReportIncomeTax: "Income Tax",
    personnelReportStampTax: "Stamp Tax",
    personnelReportUnemploymentInsurance: "Unemployment Ins.",
    personnelReportAttendanceTitle: "📅 Attendance Records (Last 10)",
    personnelReportDate: "Date",
    personnelReportCheckIn: "Check-in",
    personnelReportCheckOut: "Check-out",
    personnelReportAttendanceStatus: "Status",
    personnelReportOvertime: "Overtime",
    personnelReportPresent: "✅ Present",
    personnelReportAbsent: "❌ Absent",
    personnelReportLeave: "🌴 Leave",
    personnelReportNoDetail: "No detail data found for this personnel.",

    // Reports Final Localization RC1.1G
    reportsGenerationFailed: "Report could not be generated",
    reportsDataNotFound: "No data found",
    reportsDataLoadFailed: "Data could not be loaded",
    plPendingScrapDecision: "Pending Scrap Decision",
    plPendingScrapMessage: "NCR decision is pending for {amount} of scrap.",
    plSalesRevenue: "Sales Revenue",
    plSalesSplit30: "🌍 Sales Breakdown — Last 30 Days",
    plDomesticSales: "🏠 Domestic Sales",
    plForeignSales: "✈️ International Sales",
    plGrandTotal: "📊 Grand Total",
    plOrderUnit: "orders",
    plCustomerUnit: "customers",
    plPieceUnit: "pcs",
    plTotalOrderUnit: "total orders",
    plTotalCustomerUnit: "total customers",
    plTotalPieceUnit: "total pcs",
    plRevenueShare: "Share of total revenue",
    plDomesticLegend: "Domestic",
    plForeignLegend: "International",
    plScrapRevenue: "Scrap Revenue",
    plProductionCost: "Production Cost",
    plScrapLoss: "Scrap Loss",
    plPendingScrap: "Pending Scrap",
    plNetProfitLoss30: "NET PROFIT / LOSS (Last 30 Days)",
    plProductAnalysis: "📦 Product-Based Analysis",
    plColumnProduct: "Product",
    plColumnShippedQty: "Shipped Qty",
    plColumnConfirmedScrap: "Scrap (Confirmed)",
    plColumnPendingScrap: "Scrap (Pending)",
    plColumnScrap: "Scrap",
    plColumnNet: "Net",
    fireRecent20Title: "📋 Latest 20 Scrap Records",
    fireNoRecords: "No records",
    fireColWorkOrder: "Work Order",
    fireColOrder: "Order",
    fireColPassed: "Passed",
    fireColDate: "Date",
    fireColCreatedBy: "Created By",
    summaryFire30Title: "🔥 Scrap Summary (Last 30 Days)",
    summaryNoFire: "No scrap records found ✅",
    summaryDetailButton: "Details →",
    summaryScrapUnit: "scrap",
    historyTitle: "📋 Report History",
    historyReportType: "Report Type",
    historyFormat: "Format",
    historyDateRange: "Date Range",
    historyCreatedBy: "Created By",
    historyDate: "Date",
    historyDownload: "Download",
    historyEmpty: "No report history found",
    historyDownloadButton: "⬇ Download",

    // Variance Analysis Localization RC1.1H
    varianceFilters: "🔍 Filters",
    varianceAnalyze: "🔍 Analyze",
    varianceStartDate: "Start Date",
    varianceEndDate: "End Date",
    varianceProductCodeOptional: "Product Code (optional)",
    varianceAll: "All",
    varianceLoading: "Loading...",
    varianceTotalWorkOrders: "Total Work Orders",
    varianceSavingProvided: "Savings",
    varianceBudgetOverrun: "Budget Overrun",
    varianceSaving: "Saving",
    varianceOverrun: "Overrun",
    varianceNeutral: "Neutral",
    varianceNoData: "No data",
    varianceOrderNo: "Order No",
    varianceProductCode: "Product Code",
    varianceProduct: "Product",
    varianceQuantity: "Quantity",
    varianceStandardCost: "Standard Cost",
    varianceActualCost: "Actual Cost",
    varianceTotalVariance: "Total Variance",
    varianceNotEntered: "Not Entered",
    varianceStandard: "Standard",
    varianceActual: "Actual",
    varianceValue: "Variance",
    variancePercent: "Variance %",
    varianceStatus: "Status",
    varianceWorkOrderUnit: "work orders",
    varianceNoActualCostOrders: "No work orders with actual cost were found for this period.",
    varianceWorkOrderDetail: "Work Order Variance Detail",
    tabQualityPnl: "💹 Quality & Scrap P&L",
    tabSalesPerformance: "💼 Sales Performance",
    tabPersonnelReports: "👥 Personnel Reports",
    tabGenerateReport: "📄 Generate Report",
    tabHistory: "📋 History",
    tabVarianceAnalysis: "📉 Variance Analysis",

    // Reports Sales Performance RC1.1E
    salesPerfLoading: "Loading...",
    salesPerfNoData: "No data found",
    salesPerfTitle: "💼 Sales Performance",

    salesPeriodMonth: "This Month",
    salesPeriodQuarter: "3 Months",
    salesPeriodHalfYear: "6 Months",
    salesPeriodYear: "This Year",

    salesTotalOrders: "Total Orders",
    salesTotalRevenue: "Total Revenue",
    salesPersonnel: "Sales Personnel",
    salesActiveCustomers: "Active Customers",

    salesUnitOrders: "orders",
    salesUnitPieces: "pcs",
    salesUnitPersonnel: "people",
    salesUnitCustomers: "customers",

    salesDomestic: "Domestic",
    salesForeign: "International",
    salesAll: "All",
    salesDomesticTitle: "🏠 Domestic Sales",
    salesForeignTitle: "✈️ International Sales",

    salesPersonnelDetail: "👤 All Personnel Performance Details",

    salesColPersonnel: "Personnel",
    salesColRegion: "Region",
    salesColLevel: "Level",
    salesColOrders: "Orders",
    salesColCompleted: "Completed",
    salesColRevenue: "Total Revenue",
    salesColAvgOrder: "Avg. Order Value",
    salesColCustomer: "Customer",
    salesColTarget: "Target Achievement",
    salesColDetail: "Detail",

    salesColProductCode: "Product Code",
    salesColProductName: "Product Name",
    salesColOrderCount: "Order Count",
    salesColTotalQty: "Total Quantity",

    salesDomesticTotal: "Domestic Total",
    salesForeignTotal: "International Total",

    salesRecentOrders: "Recent Orders",
    salesOrderNo: "Order No",
    salesAmount: "Amount",
    salesStatus: "Status",
    salesStatusShipped: "Shipped",
    salesStatusPartialShipped: "Partial Shipment",
    salesStatusCompleted: "Completed",
    salesDate: "Date",

    // Sales Performance Final Polish RC1.1E
    salesOrderLabel: "Orders",
    salesCustomerLabel: "Customers",
    salesPersonnelLabel: "Personnel",
    salesOrderSuffix: "orders",
    salesTarget: "Target",
    salesDetail: "Detail",

    salesLevelDirector: "Director",
    salesLevelManager: "Manager",
    salesLevelChief: "Chief",
    salesLevelRep: "Personnel",
    salesNoTarget: "No target",
    salesTopProducts: "📦 Top-Selling Products",
    salesGrandTotal: "Grand Total",
    // Reports Management Dashboard RC1.1A
    subtitle: "Factory overview · PDF/Excel export · Scrap & Waste analysis",
    refresh: "Refresh",
    loading: "Loading data...",
    factoryOee: "Factory OEE",
    totalProduction: "Total Production",
    qualityRate: "Quality Rate",
    energyCost: "Energy Cost",
    maintenanceCost: "Maintenance Cost",
    stockValue: "Stock Value",
    activeEmployees: "Active Employees",
    scrapRate30d: "Scrap Rate (30d)",
    unitPieces: "pcs",
    unitPeople: "people",
    productionOeeTrend30d: "30-Day Production & OEE Trend",
    productionLegend: "Production",
    noProductionData: "No production data found",
    machineStatusDistribution: "Machine Status Distribution",
    noMachineData: "No machine data",

    // Reports Management Dashboard RC1.1B
    qualityRateTrend: "Quality Rate Trend",
    qualityPassLegend: "Pass %",
    qualityFailLegend: "Fail %",
    costTrend: "Cost Trend",
    noData: "No data",
    maintenanceLegend: "Maintenance",
    energyLegend: "Energy",
    productionCostLegend: "Production",
    machineStatus: {
      offline: "Offline",
      running: "Running",
      fault: "Fault",
      idle: "Idle",
      active: "Active",
    },
  },

  // Login
  login: {
    title: "Sign In",
    username: "Username",
    password: "Password",
    submit: "🔐 Login",
    error: "Invalid username or password",
    locked: "Account locked. Please wait.",
    loggingIn: "Signing in...",
    system: "Opement Smart Factory System MES · Operator Panel",
  },

  // Purchasing
  purchasing: {
    title: "Purchase Requests",
    requestNo: "Request No",
    material: "Material",
    needed: "Required",
    available: "Available",
    requested: "Requested",
    requestedBy: "Requested By",
    status: {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      ordered: "Ordered",
      received: "Received",
    },
  

      newRequest: "New Purchase Request",
      materialName: "Material Name",
      materialNamePlaceholder: "Enter material name...",
      materialCode: "Material Code",
      workOrder: "Work Order",
      workOrderNo: "Work Order No",
      workOrderPlaceholder: "Which work order is this for?",
      requestQuantity: "Request Quantity",
      priority: "Priority",
      supplier: "Supplier",
      selectSupplierOptional: "Select supplier (optional)",
      selectSupplier: "Select supplier...",
      loading: "Loading...",
      cancel: "Cancel",
      save: "Save",
      create: "Create",
      update: "Update",
      requiredMaterialQuantity: "Material name and request quantity are required.",
      requiredReceivedGood: "Received quantity and good quantity are required.",
      genericError: "Operation failed.",

      incomingQcTitle: "Incoming Material Quality Control",
      supplierLabel: "Supplier",
      orderQuantity: "Order Quantity",
      receivedQuantity: "Received Quantity",
      goodQuantity: "Good Quantity",
      brokenQuantity: "Broken Quantity",
      damagedQuantity: "Damaged/Dented Quantity",
      qualityRate: "Quality Rate",
      good: "Good",
      broken: "Broken",
      damaged: "Damaged",

      qcApprovalTitle: "QC Result Approval",
      approvalNotes: "Approval Notes",
      approvalNotesPlaceholder: "Enter your approval or rejection reason...",
      lowQualityWarning: "Quality rate is below 80%. Rejection is recommended.",
      approveAddStock: "Approve — Add to Stock",
      approve: "Approve",
      reject: "Reject",

      requestDetails: "Request Details",
      approvedBy: "Approved By",

      tabRequests: "Purchase Requests",
      tabIncomingQc: "Incoming QC",
      tabQcApproval: "QC Approval",
      pageTitle: "Purchasing & Incoming QC",
      pageSubtitle: "Material requests · Supplier orders · Incoming material quality control",
      newRequestButton: "New Request",
      deliveryWaitingMessage: "{count} orders are waiting for delivery. Click to perform incoming QC →",
      qcApprovalWaitingMessage: "{count} QC results are awaiting your approval →",

      totalRequests: "Total Requests",
      ordered: "Ordered",
      received: "Received",

      searchPlaceholder: "Search material, request no or work order...",
      allStatuses: "All Statuses",
      allPriorities: "All Priorities",
      request: "Request",
      unit: "Unit",
      stockLabel: "Stock",
      date: "Date",
      statusLabel: "Status",
      action: "Action",
      noRequests: "No purchase requests yet.",
      noMatchingRequests: "No matching requests found.",

      noPendingDelivery: "No orders waiting for delivery",
      doIncomingQc: "Perform Incoming QC",
      qcHistory: "Previous QC Records",
      orderNo: "Order No",
      expected: "Expected",
      delivered: "Delivered",
      checkedBy: "Checked By",
      qualityPercent: "Quality %",
      noPendingQcApproval: "No QC records awaiting approval",
      lowQuality: "Low Quality",
      reviewApprove: "Review & Approve",
      approvedStocked: "Approved & Added to Stock",
      urgentRequestsWaiting: "{count} urgent requests are waiting!",
      addedToStock: "{count} added to stock",

      priorityLow: "Low",
      priorityNormal: "Normal",
      priorityHigh: "High",
      priorityUrgent: "Urgent",
      statusPending: "Pending",
      statusApproved: "Approved",
      statusOrdered: "Ordered",
      statusReceived: "Received",
      statusChecked: "QC Completed",
      statusRejected: "Rejected",
      statusCancelled: "Cancelled",
      creatingRequest: "Saving...",
      createRequest: "Create Request",
      defective: "Defective",
      checkNotes: "Inspection Notes",
      checkNotesPlaceholder: "Enter your observations...",
      warehouseQcResults: "Warehouse QC Results",
      connectionError: "Connection error",
      orderCount: "orders",

      neededQuantity: "Required Quantity",
      availableQuantity: "Available Quantity",
      unitPrice: "Unit Price",
      notes: "Notes",
      missingQuantity: "Missing Quantity",
      qcWaiting: "QC Pending",

      expectedQuantity: "Expected",
      missing: "Missing",

      lastPrice: "Last price",
},

  // Kiosk
  kiosk: {
    panel: "Operator Panel",
    myOrders: "My Work Orders",
    noOrders: "No work orders assigned",
    noOrdersDesc: "Please contact your production manager",
    start: "▶ Start Production",
    pause: "⏸ Pause",
    complete: "✅ Complete",
    reportProblem: "🚨 Report Problem",
    productionProgress: "📊 Production Progress",
    orderInfo: "📋 Work Order Info",
    bom: "📋 Bill of Materials",
    inProgress: "▶ Production In Progress",
    clickForDetail: "👆 Click for details and actions",
  },

  machines: {
    title: "Machine Management",
    subtitle: "Live monitoring · OEE tracking · Fault history · Add machine",
    addMachine: "Add Machine",
    editMachine: "Edit Machine",
    refresh: "Refresh",
    detail: "Detail",
    edit: "Edit",
    cancel: "Cancel",
    save: "Save",
    update: "Update",
    add: "Add",
    saving: "Saving...",
    loading: "Loading...",
    noMachines: "No machines found",
    machineCount: "machines",
    allStatuses: "All Statuses",
    searchPlaceholder: "Search machine name or ID...",
    actions: "Actions",
    // Form fields
    machineId: "Machine ID",
    machineName: "Machine Name",
    machineType: "Type",
    location: "Location",
    brand: "Brand",
    model: "Model",
    serialNo: "Serial No",
    statusLabel: "Status",
    notes: "Notes",
    // Errors
    errIdNameRequired: "Machine ID and name are required.",
    errGeneric: "Error",
    // Status labels
    statusRunning: "Running",
    statusStopped: "Stopped",
    statusFault: "Fault",
    statusMaintenance: "Maintenance",
    statusIdle: "Idle",
    // Detail tabs
    tabOverview: "Live SCADA",
    tabMachineInfo: "Machine Information",
    tabOee: "OEE & Performance",
    tabFaults: "Fault History",
    tabMaintenance: "Maintenance Schedule",
    tabAlarms: "Alarm History",
    tabParts: "Spare Parts",
    tabStatusLog: "Status Log",

    // Live SCADA
    noDataReceived: "No data received",
    now: "Now",
    secondsAgo: "sec ago",
    minutesAgo: "min ago",
    hoursAgo: "hr ago",
    lastData: "LAST DATA",
    spindleSpeed: "SPINDLE SPEED",
    feedProgress: "PROGRESS",
    last60Measurements: "LAST 60 MEASUREMENTS",
    waitingForLiveData: "WAITING FOR LIVE DATA",
    productionUpper: "PRODUCTION",
    cycleUpper: "CYCLE",
    scrapUpper: "SCRAP",
    pcsUnit: "pcs",

    machineUnreachable: "Machine unreachable",
    telemetryDisconnected: "Live telemetry disconnected. Last data received:",
    activeFanucAlarm: "ACTIVE FANUC ALARM",
    connectionActiveNoAlarm: "Machine connection active — no alarms",

    activeWorkOrder: "Active Work Order",
    product: "Product",
    operator: "Operator",
    productionQuality: "Production & Quality",
    produced: "Produced",
    reworkRequired: "Requires rework:",
    noActiveWorkOrder: "No active work order",
    workOrderDataHint: "Production and quality values will be displayed here when the work order starts.",

    cncProgram: "CNC Program",
    programName: "Program Name",
    tool: "Tool",
    lineBlock: "Line / Block",

    liveOee: "Live OEE",
    statusTimeline: "Status Timeline",
    feedRate: "Feed Rate",
    program: "Program",
    partCount: "Part Count",
    alarm: "Alarm",
    none: "None",
    lastSeen: "Last Data",
    connection: "Connection",
    driver: "Driver",

    // Live time / OEE / status descriptions
    quality: "Quality",
    oee7days: "7-Day OEE Trend",
    dataUnavailable: "No data received",
    connectionLost: "Connection Lost",
    waitingWorkOrder: "Waiting for Work Order",
    machineAlarmReason: "Machine alarm triggered. Alarm code:",
    machineAlarmTransition: "Machine entered alarm state.",
    machineTelemetryLostReason: "Telemetry connection to the machine was lost.",
    machineMovementResumed: "Machine movement resumed.",
    statusReasonUnavailable: "No detailed reason was recorded for this status change.",
    machineStoppedReason: "Machine stopped.",
    machineRunningReason: "Machine started running.",
    // Overview tab
    machineInfo: "Machine Info",
    productionInfo: "Production Info",
    temperature: "Temperature",
    production: "Production",
    defective: "Defective",
    shift: "Shift",
    lastUpdate: "Last Update",
    defectRate: "Defect Rate",
    purchaseDate: "Purchase Date",
    warrantyEnd: "Warranty End",
    // OEE tab
    oee14days: "14-Day OEE Trend",
    noOeeHistory: "No OEE history found",
    availability: "Availability %",
    performance: "Performance %",
    // Faults tab
    noFaults: "No fault records found",
    faultType: "Fault Type",
    description: "Description",
    durationMin: "Duration (min)",
    date: "Date",
    // Spare parts tab
    noParts: "No spare parts found",
    partName: "Part Name",
    category: "Category",
    unit: "Unit",
    stock: "Stock",
    minStock: "Min. Stock",
    critical: "Critical",
    sufficient: "Sufficient",
    // Stats
    totalMachines: "Total Machines",
    running: "Running",
    fault: "Fault",
    avgOee: "Avg. OEE",
    machine: "Machine",
  },

  machinesx: {
    livePower: "Live Power",
    machinePartCounter: "Machine Part Counter",
    todayProduced: "Produced Today",
    shiftTarget: "Shift Target",
    shiftScrap: "Shift Scrap",
    workOrderTarget: "Work Order Target",
    totalProduced: "Total Produced",
    workOrderScrap: "Work Order Scrap",
    workOrderRemaining: "Work Order Remaining",
    title: "Machine Management",
    subtitle: "Real-time monitoring · OEE analysis · Maintenance tracking",
    addMachine: "Add Machine",
    editMachine: "Edit Machine",
    refresh: "Refresh",
    detail: "Detail",
    edit: "Edit",
    close: "Close",
    cancel: "Cancel",
    update: "Update",
    add: "Add",
    saving: "Saving...",
    loading: "Loading...",
    loadingMachines: "Loading machines...",
    noMachinesYet: "No machines registered yet.",
    noMatch: "No machines match the filters.",
    noMachines: "No machines found",
    machineShowing: "machines shown",
    allStatuses: "All Statuses",
    allTypes: "All Types",
    searchPlaceholder: "Search machine name or ID...",
    actions: "Actions",
    retry: "Retry",
    // Status labels
    statusRunning: "Running",
    statusIdle: "Idle",
    statusMaintenance: "Maintenance",

    statusStale: "Data Delayed",
    statusAlarm: "Alarm",
    statusSetup: "Setup",
    statusToolChange: "Tool Change",
    statusUnknown: "Unknown",

    productionRunning: "Production Running",
    productionPaused: "Production Paused",
    productionCompleted: "Production Completed",

    errSaveMachine: "Machine could not be saved",

    durationLabel: "Duration",
    costLabel: "Cost",
    hoursShort: "hrs",
    resolvedClosed: "Resolved / Closed",
    completedLabel: "Completed",
    criticalUpper: "CRITICAL",
    infoUpper: "INFO",
    minimumStockUpper: "MINIMUM STOCK",
    supplierLabel: "Supplier",
    operatorLabel: "Operator",

    // RC1.1D — final UI labels
    warningUpper: "WARNING",
    pendingLabel: "Pending",
    inProgressLabel: "In Progress",
    maintenanceCompletionLabel: "Completed",
    eventDateLabel: "Date",
    minimumLabel: "Minimum",
    unitPriceLabel: "Unit Price",
    codeLabel: "Code",
    minutesShort: "min",

    filterRunning: "Running",
    filterIdle: "Idle",
    filterFault: "Alarm",
    filterStopped: "Stopped",
    statusFault: "Fault",
    statusStopped: "Stopped",
    // Form fields
    machineName: "Machine Name",
    machineId: "Machine ID",
    machineType: "Type",
    location: "Location",
    productionLine: "Production Line",
    serialNo: "Serial No",
    brand: "Brand",
    model: "Model",
    purchaseDate: "Purchase Date",
    warrantyEnd: "Warranty End",
    statusLabel: "Status",
    authOperators: "Auth. Operators",
    notes: "Notes",
    lathe: "Lathe",
    press_: "Press",
    welding: "Welding",
    assembly: "Assembly",
    conveyor: "Conveyor",
    other: "Other",
    // Errors
    errNameIdRequired: "Machine name and ID are required.",
    errFetch: "Could not load machines",
    errGeneric: "Error",
    // Detail tabs
    tabOverview: "Live SCADA",
    tabOee: "OEE & Performance",
    tabFaults: "Fault History",
    tabMaintenance: "Maintenance Schedule",
    tabAlarms: "Alarm History",
    tabParts: "Spare Parts",
    tabStatusLog: "Status Log",

    // Machines Localization Final
    tabMachineInfo: "Machine Information",
    noDataReceived: "No data received",
    now: "Now",
    secondsAgo: "sec ago",
    minutesAgo: "min ago",
    hoursAgo: "hr ago",
    lastData: "LAST DATA",
    spindleSpeed: "SPINDLE SPEED",
    feedProgress: "PROGRESS",
    last60Measurements: "LAST 60 MEASUREMENTS",
    waitingForLiveData: "WAITING FOR LIVE DATA",
    productionUpper: "PRODUCTION",
    cycleUpper: "CYCLE",
    scrapUpper: "SCRAP",
    pcsUnit: "pcs",
    machineUnreachable: "Machine unreachable",
    telemetryDisconnected: "Live telemetry disconnected. Last data received:",
    telemetryNoNewData: "No new telemetry is being received from the machine.",
    activeFanucAlarm: "ACTIVE FANUC ALARM",
    connectionActiveNoAlarm: "Machine connection active — no alarms",
    activeWorkOrder: "Active Work Order",
    product: "Product",
    operator: "Operator",
    productionQuality: "Production & Quality",
    produced: "Produced",
    reworkRequired: "Requires rework:",
    noActiveWorkOrder: "No active work order",
    workOrderDataHint: "Production and quality values will be displayed here when the work order starts.",
    cncProgram: "CNC Program",
    programName: "Program Name",
    tool: "Tool",
    lineBlock: "Line / Block",
    liveOee: "Live OEE",
    statusTimeline: "Status Timeline",
    feedRate: "Feed Rate",
    program: "Program",
    partCount: "Part Count",
    alarm: "Alarm",
    none: "None",
    lastSeen: "Last Data",
    connection: "Connection",
    driver: "Driver",
    dataUnavailable: "No data received",
    connectionLost: "Connection Lost",
    waitingWorkOrder: "Waiting for Work Order",
    machineAlarmReason: "Machine alarm triggered. Alarm code:",
    machineStoppedReason: "Machine stopped.",
    machineRunningReason: "Machine started running.",
    // Metric cards
    hours: "hrs",
    avgMtbf: "Avg. Mean Time Between Failures",
    avgMttr: "Avg. Mean Time to Repair",
    maintenanceCost: "Maintenance Cost",
    availability: "Availability",
    performance: "Performance",
    quality: "Quality",
    // Passport
    passport: "Machine Passport",
    brandModel: "Brand / Model",
    location_: "Location",
    lastMaintenance: "Last Maintenance",
    nextMaintenance: "Next Maintenance",
    all: "All",
    // Live params
    liveParams: "Live Parameters",
    temperature: "Temperature",
    vibration: "Vibration",
    energy: "Energy",
    rpm: "RPM",
    cycleTime: "Cycle Time",
    targetCycle: "Target Cycle",
    riskScore: "Risk Score",
    opcua: "OPC-UA/MQTT",

    // Machine card final localization
    activeAlarmUpper: "ACTIVE ALARM",
    noActiveAlarm: "No active alarm",
    alarmFallback: "Alarm",
    alarmSv0410: "X-axis servo load is high",
    notConnected: "Not connected",
    // OEE
    oee7days: "7-Day OEE Trend",
    noOeeHistory: "No OEE history found",
    // Faults
    noFaults: "No fault records found",
    date: "Date",
    faultType: "Fault Type",
    description: "Description",
    duration: "Duration",
    resolution: "Resolution",
    min: "min",
    // Maintenance
    noMaintenance: "No maintenance records found",
    // Alarms
    noAlarms: "No alarm records found",
    datetime: "Date/Time",
    level: "Level",
    salesHierarchy: "Sales Hierarchy",
    reportsTo: "Reports To",
    activeUser: "Active user",
    message: "Message",
    warning: "WARNING",
    acknowledged: "Acknowledged",
    waiting: "Pending",
    // Spare Parts
    noPartsLinked: "No spare parts linked",
    stockCode: "Stock Code",
    stock: "Stock",
    // Status Log
    noStatusLog: "No status log found",
    // Card
    risk: "Risk",
    // Stats
    total: "Total",
    running_: "Running",
    faultMaintenance: "Maint./Fault",
    avgOee: "Avg. OEE",
    machine_: "Machine",
    // Live Machine Card RC2
    spindleCard: "Spindle",
    feedCard: "Feed",
    cycleCard: "Cycle",
    productionCard: "Production",
    targetCard: "Target",
    scrapCard: "Scrap",
    temperatureCard: "Temperature",
    liveDataUnavailable: "Live data connection unavailable",
  },

  scrap: {
    title: "Scrap & Recycling",
    subtitle: "Production scrap · Tools · Oil/Fluid · Auto QC integration",
    loading: "Loading...",
    tabRecords: "Scrap",
    tabTools: "Tools",
    tabFluids: "Oil/Fluid",
    tabDefinitions: "Definitions",
    tabAnalytics: "Analytics",
    addScrap: "Add Scrap",
    addTool: "Add Tool",
    addFluid: "Add Fluid",
    addDef: "Add Definition",
    save: "Save",
    update: "Update",
    cancel: "Cancel",
    saving: "Saving...",
    kpiWeight: "Total Weight (30d)",
    kpiValue: "Scrap Value",
    kpiRecovery: "Recovery",
    kpiPending: "Pending Records",
    kpiAuto: "automatic",
    kpiToolFluid: "Tools + Oil",
    secSource: "Source Info",
    secMaterial: "Material Type",
    secQtyValue: "Qty & Value",
    secRecovery: "Recovery / Disposal",
    editRecord: "Edit Scrap Record",
    newRecord: "New Scrap Record",
    autoNote: "Auto-generated — source fields are locked",
    autoLockNote: "This record was auto-generated by the system. Product code and work order cannot be changed, but you can update recovery info.",
    formSubtitle: "Production scrap / recycling tracking",
    sourceType: "Source Type",
    sourceManual: "Manual Entry",
    sourceWorkOrder: "Work Order",
    sourceKkReject: "QC Reject",
    sourceGeneral: "General / Mixed",
    productCode: "Product Code",
    productSearchPlaceholder: "FRN-001 or product name...",
    workOrderNo: "Work Order No",
    materialType: "Material Type",
    scrapCategory: "Scrap Category",
    catQualityReject: "Quality Reject",
    catMachineFault: "Machine Fault",
    catMaterialError: "Material Error",
    catOperatorError: "Operator Error",
    catMixed: "Mixed / General",
    catOther: "Other",
    date: "Date",
    weightKg: "Weight (kg)",
    totalValue: "Total Value",
    description_: "Description",
    scrapReasonPlaceholder: "Reason for scrap...",
    method: "Method",
    company: "Company",
    companyPlaceholder: "Scrap dealer / company",
    recoveryAmount: "Recovery (₺)",
    statusLabel: "Status",
    notes: "Notes",
    select: "Select",
    recHurdaciSat: "Sell to Dealer",
    recYenidenIsle: "Rework",
    recGeriHammadde: "Return to Raw Material",
    recLisanliImha: "Licensed Disposal",
    recBeklemede: "Pending",
    recImha: "Dispose",
    statusBeklemede: "Pending",
    statusIsleniyor: "Processing",
    statusTamamlandi: "Completed",
    statusToplandi: "Collected",
    statusSatildi: "Sold",
    toolElmasUc: "Diamond Insert",
    toolFreze: "Milling Blade",
    toolMatkap: "Drill Bit",
    toolTaslamaTasi: "Grinding Wheel",
    toolDiger: "Other",
    fluidHidrolik: "Hydraulic Oil",
    fluidKesme: "Cutting Fluid",
    fluidSogutma: "Coolant",
    fluidMotor: "Motor Oil",
    fluidDiger: "Other",
    catMetal: "Metal",
    catPlastik: "Plastic",
    catYag: "Oil/Fluid",
    catTakim: "Tool",
    toolFormTitle: "Tool Scrap Record",
    toolName: "Tool Name",
    toolType: "Tool Type",
    machine_: "Machine",
    quantity_: "Quantity",
    unitPrice: "Unit Price (₺)",
    total: "Total",
    pcs: "pcs",
    fluidFormTitle: "Oil / Fluid Scrap Record",
    fluidType: "Fluid Type",
    volumeLt: "Volume (lt)",
    containerCount: "Container Count",
    containerType: "Container Type",
    barrel: "Barrel",
    canister: "Canister",
    tank: "Tank",
    collectionCompany: "Collection Company",
    collectionDate: "Collection Date",
    salePrice: "Sale Price (₺)",
    editDef: "Edit Definition",
    newDef: "Product Scrap Definition",
    defSubtitle: "Required for QC automation",
    defHint: "Example: For FRN-001, each passed product produces 0.5 kg chips, each failed product produces 2.5 kg scrap.",
    scrapPerUnit: "Per Passed Product (kg)",
    scrapPerUnitNote: "Chips per passed QC product",
    rejectWeight: "Reject Product Weight (kg)",
    rejectWeightNote: "Each product failing QC",
    reject: "reject",
    scrapRecords: "Scrap Records",
    records_: "records",
    product: "Product",
    material: "Material",
    weight: "Weight",
    value: "Value (₺)",
    recovery: "Recovery",
    noRecords: "No scrap records found",
    addFirst: "Add First Record",
    toolScrapTitle: "Tool Scrap (Inserts, Milling etc.)",
    noTools: "No tool scrap records found",
    fluidScrapTitle: "Oil & Fluid Scrap",
    noFluids: "No oil/fluid scrap records found",
    defTitle: "Product Scrap Definitions",
    defCount: "definitions",
    defInfo: "Product-based definitions allow the system to auto-create scrap records when QC is completed.",
    noDefs: "No definitions yet.",
    searchPlaceholder: "Product code, work order, material...",
    allStatuses: "All Statuses",
    allMethods: "All Methods",
    analyticsMaterialCat: "Material Category",
    analyticsRecoveryMethod: "Recovery Method",
    analyticsDailyTrend: "Daily Scrap Trend (30 Days)",
    analyticsTopProducts: "Scrap by Product (Top 10)",
    totalScrapValue: "Total Scrap Value",
    totalRecovery: "Total Recovery",
    netLoss: "Net Loss",
    noData: "No data",
    noTrendData: "No trend data",
    errProductCode: "Product code is required",
    errWeight: "Weight is required",
    errSave: "Could not save",
    errToolName: "Tool name is required",
    errVolume: "Volume is required",
    errMaterialType: "Material type is required",
    confirmDelete: "This will be deleted. Are you sure?",
    confirmDeleteDef: "Definition will be deleted. Are you sure?",
  
    catDiger: "Other",
    paginationScrapRecord: "scrap records",
    paginationToolScrap: "tool scrap",
    paginationFluidWaste: "fluid waste",
    paginationScrapDefinition: "scrap definitions",
},

  qualityPage: {
    title: "Quality & Shipment",
    subtitle: "Quality control · Product approval · Customer shipment",
    refresh: "Refresh",
    loading: "Loading...",
    retry: "Retry",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    goBack: "Go Back",
    yesCancelIt: "Yes, Cancel It",
    pcs: "pcs",
    tabQC: "Quality Control",
    tabShipment: "Shipment",
    addQCRecord: "QC Record",
    addShipment: "Shipment",
    qcPending: "Pending",
    qcPassed: "Passed",
    qcFailed: "Failed",
    qcPartial: "Partial Pass",
    qcRework: "Rework",
    qcScrap: "Scrap",
    shipDraft: "Draft",
    shipReady: "Ready",
    shipPending: "Pending",
    shipShipped: "Shipped",
    shipDelivered: "Delivered",
    shipCancelled: "Cancelled",
    totalQC: "Total QC",
    passed_: "Passed",
    failed_: "Failed",
    avgPass: "Avg. Pass",
    totalShip: "Total Shipments",
    shipped_: "Shipped",
    pending_: "Pending",
    allStatuses: "All Statuses",
    searchQC: "Search product, work order or inspector...",
    searchShip: "Search customer, product or order...",
    noQCRecords: "No quality control records.",
    noShipments: "No shipment records.",
    noMatch: "No matching records found.",
    qcRecordCount: "QC records",
    shipRecordCount: "shipments",
    customer_: "Customer",
    productName_: "Product",
    productCode: "Product Code",
    workOrder: "Work Order",
    inspector: "Inspector",
    total_: "Total",
    checked_: "Checked",
    passPct: "Pass %",
    passRate: "Pass Rate",
    statusLabel: "Status",
    totalOrder: "Order Qty",
    shippedQty: "Shipped Qty",
    orderNo: "Order No",
    shipDate: "Ship Date",
    shipProgress: "Shipment Progress",
    order_: "Order",
    remaining_: "Remaining",
    product_: "Product",
    woShort: "WO",
    inspectionDetails: "Inspection Details",
    productName: "Product Name",
    lotNo: "Lot No",
    notes_: "Notes",
    inspDate: "Inspection Date",
    thisQcTotal: "This QC Total",
    thisQcPassed: "This QC Passed",
    thisQcFailed: "This QC Failed",
    thisQcPct: "This QC Pass %",
    qcCancelConfirm: "Are you sure you want to cancel this QC record?",
    qcCancelledMsg: "QC record cancelled.",
    shipment: "Shipment",
    totalQty: "Total Quantity",
    shippedOf: "Shipped",
    remainingToShip: "Remaining to Ship",
    readyToShip: "ready to ship",
    doShipment: "Ship",
    shipNow: "Ship",
    invoiceRequired: "Cannot ship without an invoice. Please mark the invoice first.",
    invoiceRequiredShip: "Cannot ship without an invoice. Please mark invoice from the sales order.",
    invoiceRequiredCard: "Not invoiced — shipment not allowed",
    shipQtyLabel: "Qty to ship (max: {n} pcs)",
    allShipped: "All products have been shipped.",
    shipCancelConfirm: "Are you sure you want to cancel this shipment?",
    willBeReturned: "will be returned to stock.",
    cancelReasonPlaceholder: "Cancellation reason...",
    shipCancelledMsg: "Shipment cancelled.",
    shipCancelledStock: "Cancelled. {n} pcs added back to stock.",
    customerCancel: "Customer cancellation — returned to warehouse",
    notInvoiced: "Not invoiced",
    newQCRecord: "Quality Control Record",
    workOrderSelect: "Work Order",
    onlyInProduction: "Only work orders in production",
    selectWO: "Select Work Order",
    noWOInProduction: "No work orders currently in production.",
    orderQty: "Order Quantity",
    prevPassed: "Previously Passed",
    remainingQC: "Remaining QC",
    woPassRate: "Work Order Overall Pass Rate",
    wo100Pct: "This work order is 100% quality checked.",
    checkedQty: "Checked Quantity",
    failQty: "Failed Quantity",
    passQtyAuto: "Passed Quantity (Auto)",
    inspType: "Inspection Type",
    inspFinal: "Final Inspection",
    inspInProcess: "In-Process",
    inspIncoming: "Incoming",
    inspOutgoing: "Outgoing",
    max: "Max",
    date_: "Date",
    editShipment: "Edit Shipment",
    selectPendingShipment: "Select Pending Shipment",
    selectShipment: "Select Shipment",
    noPendingShipments: "No pending shipments.",
    noCustomer: "No Customer",
    shippable: "Shippable",
    thisShipQty: "This Shipment Qty",
    unit_: "Unit",
    carrier: "Carrier",
    partialShipNote: "Partial Shipment: {qty} / {max} {unit}. Remaining: {remaining} {unit} will wait.",
    allPendingWillShip: "All pending quantity will be shipped.",
    errSelectShipment: "Please select a shipment.",
    errMaxShip: "Maximum shippable",
    errFetchQC: "Could not load quality data",
    errSelectWO: "Please select a work order.",
    errQtyZero: "Checked quantity must be greater than 0.",
    errQtyExceeds: "Passed + failed cannot exceed total quantity.",
    err100Pct: "This work order is 100% quality checked.",
    errRemainingQty: "Remaining QC quantity",
    errShipQtyZero: "Ship quantity must be greater than 0.",
    errShipMaxPrefix: "Maximum",
    errShipUpdate: "Could not update shipment.",
    errSave: "Error",
    cancelFailed: "Cancellation failed.",
    connectionError: "Connection error.",

    // RC1.1A — workflow / assembly / defective component labels
    finalQcPassedLabel: "✅ Final QC Passed",
    inProcessQcPassedLabel: "✅ In-Process QC Passed",

    woStatusCompleted: "✅ Completed",
    woStatusPlanned: "📋 Planned",
    woStatusInProgress: "🔄 In Production",
    woStatusAssemblyWaiting: "⏳ Waiting for Assembly",
    woStatusQcWaiting: "🧪 Waiting for In-Process QC",
    woStatusFinalQcWaiting: "🧪 Waiting for Final QC",
    woStatusWaiting: "📋 Waiting",

    assemblyInProgress: "🔧 In Assembly",
    assemblyPending: "⏳ Waiting for Assembly",
    assemblyCompleted: "✅ Assembly Completed",

    defectiveComponents: "🔴 Defective Components",
    dispositionRemanufacture: "🔄 Remanufacture",
    dispositionStock: "📦 Fulfill from Stock",
    dispositionPurchase: "🛒 Purchase",
    dispositionScrap: "🗑️ Scrap",
    dispositionUseAsIs: "✅ Use As Is",

    // RC1.1C — semantic final
    component: "Component",
    stock: "Stock",
    pieceCount: "Qty",
    defectType: "Defect Type",
    decision: "Decision",

    defectDimensional: "Dimensional",
    defectVisual: "Visual",
    defectFunctional: "Functional",
    defectMaterial: "Material",
    defectOther: "Other",

    totalOrderLabel: "Total Order",
    passedQtyLabel: "Passed",

    errFullShipmentBeforeDelivered: "The full shipment must be completed before marking it as delivered.",
  },

  qualityCost: {
    title: "Quality Cost Report",
    subtitle: "Cost of Quality · NCR Costs · Recurring Problems · ISO 9001",
    loading: "Loading...",
    jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr",
    may: "May", jun: "Jun", jul: "Jul", aug: "Aug",
    sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec",
    catDimensional:   "Dimensional",
    catVisual:        "Visual",
    catFunctional:    "Functional",
    catMaterial:      "Material",
    catProcess:       "Process",
    catDocumentation: "Documentation",
    catOther:         "Other",
    kpiTotalCost:      "Total Quality Cost",
    kpiInternalError:  "Internal Failure Cost",
    kpiInternalSub:    "Labor + Machine",
    kpiExternalError:  "External Failure Cost",
    kpiExternalSub:    "Shipping + Penalty",
    kpiScrapLoss:      "Net Scrap Loss",
    kpiCustomerReturn: "Customer Returns",
    records:           "records",
    thisMonth:         "This month",
    tabSummary:    "Summary",
    tabRecurring:  "Recurring",
    tabKaizen:     "Kaizen Suggestions",
    tabTrend:      "Trend",
    costBreakdown:  "Cost Breakdown",
    internalError:  "Internal Failure (Labor, Machine)",
    rework:         "Rework",
    externalError:  "External Failure (Shipping, Penalty)",
    otherImpact:    "Other Quality Impact",
    scrapNetLoss:   "Net Scrap Loss",
    total:          "TOTAL",
    errorCategory:  "Failure Category",
    ncrCount:       "NCR Count",
    costTl:         "Cost (₺)",
    noNcrThisMonth: "No NCR this month",
    criticalNcr:    "Critical NCR",
    scrapWeight:    "Scrap Weight",
    recovery:       "Recovery",
    noRecurring:    "No recurring problems this month! Great.",
    recurringTitle: "Recurring Problems — Urgent Kaizen Required!",
    product:        "products",
    productCode:    "Product Code",
    totalCost:      "Total Cost",
    severities:     "Severities",
    riskLevel:      "Risk Level",
    riskCritical:   "CRITICAL",
    riskHigh:       "HIGH",
    riskMedium:     "MEDIUM",
    times:          "times",
    kaizenInfo:       "Auto-generated Kaizen suggestions for products with 2+ NCRs in the last 90 days. Root cause analysis should be done before these problems recur.",
    noKaizen:         "No recurring problems in the last 90 days.",
    urgencyVeryUrgent:"Very Urgent",
    urgencyUrgent:    "Urgent",
    urgencySuggested: "Suggested",
    last90Days:       "In the last 90 days",
    recorded:         "NCR records",
    totalCost_:       "Total cost",
    kaizenAction:     "Suggested Action: Perform root cause analysis → Create CAPA → Update process control plan",
    trend12months:    "12-Month Quality Cost Trend",
    trendQualityCost: "Quality Cost",
    trendNcrCount:    "NCR Count",
    trendReturns:     "Customer Returns",
    noTrendData:      "No trend data",
    monthlyDetail:    "Monthly Detail",
    month_:           "Month",
    customerReturn:   "Customer Returns",
    qualityCost_:     "Quality Cost",
    statusLabel:      "Status",
    statusCritical:   "Critical",
    statusHigh:       "High",
    statusNormal:     "Normal",
    noData:           "No data",
  },

  stockPage: {
    title: "Stock & Suppliers",

    // RC1.1B — Assembly Material Requests
    assemblyRequestsTitle: "🔧 Material Requests for Assembly",
    assemblyRequest: "Request",
    assemblyWorkOrder: "Work Order",
    assemblyMaterial: "Material",
    assemblyQuantity: "Quantity",
    assemblyRequestedBy: "Requested By",
    assemblyStock: "Stock",
    assemblyStatus: "Status",
    assemblyAction: "Action",
    assemblyInStock: "🟢 In Stock",
    assemblyOutOfStock: "🔴 Out of Stock",
    assemblyDefaultReason: "Assembly material request",

    assemblyApproveNote: "Assembly request delivered",
    assemblyDeliveredSuccess: "Material delivered ✅",
    assemblyRejectReasonPrompt: "Rejection reason:",
    assemblyRejectedSuccess: "Request rejected",

    assemblyStatusWaiting: "⏳ Waiting",
    assemblyStatusDelivered: "✅ Delivered",
    assemblyStatusRejected: "❌ Rejected",

    assemblyNoPending: "No pending assembly requests",
    assemblyNoPendingHint: "Requests created from the Assembly screen will appear here",

    approveAssemblyRequest: "Approve",
    rejectAssemblyRequest: "Reject",

    subtitle: "Material management · Movements · Supplier performance",
    refresh: "Refresh",
    loading: "Loading...",
    retry: "Retry",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    update: "Update",
    add: "Add",
    edit: "Edit",
    detail: "Detail",
    actions: "Actions",
    tabRaw:       "Raw Materials",
    tabFinished:  "Finished Goods",
    tabSemi:      "Semi-Finished Stock",
    tabSuppliers: "Suppliers",
    tabRequests:  "Consumable Requests",
    addMaterial:  "Add Material",
    addProduct:   "Add Product",
    addSemi:      "Add Semi-Finished",
    addSupplier:  "Add Supplier",
    newMaterial:  "New Material",
    newSupplier:  "New Supplier",
    statusEmpty:   "Empty",
    statusLow:     "Critical",
    statusWarning: "Low",
    statusOk:      "Sufficient",
    statusLabel:   "Status",
    allStatuses:   "All Statuses",
    allCategories: "All Categories",
    movReceipt:  "Goods Receipt",
    movIssue:    "Goods Issue",
    movTransfer: "Transfer",
    movAdjust:   "Count Adjustment",
    materialName:  "Material Name",
    stockCode:     "Stock Code",
    category:      "Category",
    currentStock:  "Current Stock",
    minStock:      "Min. Stock",
    maxStock:      "Max. Stock",
    unit_:         "Unit",
    unitPrice:     "Unit Price",
    totalValue_:   "Total Value",
    supplier_:     "Supplier",
    lastReceipt:   "Last Receipt",
    lastIssue:     "Last Issue",
    location:      "Location",
    planningParams: "Planning Parameters",
    reorderPoint:   "Reorder Point",
    eoq:            "EOQ (Economic Order Qty)",
    safetyStock:    "Safety Stock",
    leadTime:       "Lead Time",
    days:           "days",
    dayShort:       "d",
    batchTracking:  "Batch Tracking",
    serialTracking: "Serial Tracking",
    qualityCheck:   "Quality Check",
    fifoLifo:       "FIFO / LIFO",
    abcClass:       "ABC Class",
    abcCritical:    "Critical",
    abcImportant:   "Important",
    abcLow:         "Low",
    active:         "Active",
    passive:        "Inactive",
    required:       "Required",
    notRequired:    "Not Required",
    materialInfo:   "Material Info",
    stockLevel:     "Stock Level",
    tabOverview:    "Overview",
    tabMovements:   "Movements",
    tabReorder:     "Reorder",
    date_:          "Date",
    type_:          "Type",
    qty:            "Qty",
    afterStock:     "Stock After",
    notes:          "Notes",
    user:           "User",
    noMovements:    "No movement records found",
    autoPurchaseSuggestion: "Auto Purchase Suggestion",
    suggestedOrder: "Suggested Order",
    reorderAlert:   "Stock has reached reorder point! An automatic purchase request can be sent to the supplier.",
    lastPrice:      "Last price",
    unitPriceTl:    "Unit Price (₺)",
    package:        "Package",
    pcs:            "pcs",
    inUnit:         "in unit",
    quantity:       "Quantity",
    reserved:       "Reserved",
    openWO:         "Open Work Orders",
    available:      "Available",
    generalSupplier: "General Supplier",
    productCount:   "Product Count",
    activeOrders:   "Active Orders",
    leadTimeDays:   "Lead Time",
    paymentDays:    "Payment Terms",
    contact:        "Contact",
    contactPerson:  "Contact Person",
    phone_:         "Phone",
    email_:         "Email",
    address_:       "Address",
    city_:          "City",
    taxNo:          "Tax No",
    performance:    "Performance",
    rating_:        "Rating",
    deliverySuccess:"Delivery Rate",
    qualityScore:   "Quality Score",
    leadTimeDaysLabel: "Lead Time (days)",
    paymentDaysLabel:  "Payment Terms (days)",
    rating1to5:     "Rating (1-5)",
    contractEnd:    "Contract End",
    totalPurchase:  "Total Purchase",
    lastOrder:      "Last Order",
    recentOrders:   "Recent Orders",
    noOrders:       "No order records",
    material:       "Material",
    amount:         "Amount",
    delivered:      "Delivered",
    waiting:        "Pending",
    totalProducts:  "Total Products",
    totalSemi:      "Total Semi-Finished",
    readyToShip_:   "Ready to Ship",
    finishedStockInfo: "Finished goods stock is automatically updated from completed work orders. Issues are done via the Shipment module.",
    searchProduct:  "Search product name or code...",
    noFinishedGoods:"No finished goods in stock yet.",
    noProductFound: "No products found",
    productName:    "Product",
    productNameHeader: "Product Name",
    noProductMatch: "No matching products found.",
    productCode:    "Product Code",
    total_:         "Total",
    workOrder:      "Work Order",
    customer:       "Customer",
    productionDate: "Production Date",
    source:         "Source",
    pendingWarehouse:"Pending Warehouse",
    shipped:        "Shipped",
    ready:          "Ready",
    customerCancel: "Customer Cancellation",
    customerCancelNote: "This product was returned to warehouse due to customer cancellation",
    warehouseAcceptNote: "Warehouse acceptance note (optional):",
    warehouseAccepted:   "Product accepted to warehouse!",
    acceptToWarehouse:   "Accept to Warehouse",
    normalProduction:    "Normal Production",

    // Semi-finished
    semiStockInfo: "Semi-finished stock is updated when child work orders are completed or through manual receipt. It is consumed automatically when the work order starts.",
    searchSemi:    "Search semi-finished name or code...",
    noSemiGoods:   "No semi-finished stock.",
    semiCount:     "semi-finished",
    manualSource:  "✋ Manual",
    productionSource: "🏭 Production",
    inStock:        "In Stock",
    inStockSemi:     "In Stock",
    reservedSemi:    "Reserved",
    mainWarehouse:  "Main Warehouse",
    totalItems:     "Total Items",
    criticalStock:  "Critical Stock",
    supplierCount:  "Suppliers",
    criticalStockAlert: "items at critical stock level! Creating a purchase request is recommended.",
    searchMaterial: "Material name or stock code...",
    noMaterials:    "No material records yet.",
    noMaterialFound:"No materials found",
    noMatch:        "No materials match the filters.",
    loadingStock:   "Loading stock...",
    noSuppliers:    "No supplier records.",
    noSupplierMatch: "No matching suppliers found.",
    searchSupplier: "Search supplier...",
    supplierName:   "Supplier Name",
    code:           "Code",
    materialCount:  "materials",
    finishedCount:  "finished goods",
    supplierCount_: "suppliers",
    requestCount:   "requests",
    reqTotal:       "Total",
    reqPending:     "Pending",
    reqApproved:    "Approved",
    reqRejected:    "Rejected",
    reqAll:         "All",
    requestConsumable: "Request Consumable",
    newRequest:     "New Consumable Request",
    reqMaterialPlaceholder: "Cutting tool, oil, gloves...",
    current:        "Current",
    department:     "Department",
    deptPlaceholder:"Production, Maintenance...",
    machine_:       "Machine",
    reqReason:      "Request Reason",
    reqReasonPlaceholder: "Consumed, Broken, Stock low...",
    sendRequest:    "Submit Request",
    requestedBy:    "Requested By",
    noRequests:     "No requests found",
    approve:        "Approve",
    reject:         "Reject",
    rejectReasonPrompt: "Rejection reason:",

    // RC1.1C.4 — final status/action labels
    requestDelivered: "Delivered",
    requestDeliveredCount: "Delivered",
    stockUnavailable: "No Stock",
    deliverAction: "Deliver",
    semiStatusInStock: "✅ In Stock",
    semiStatusWaiting: "⏳ Pending",
    errValidQty:    "Please enter a valid quantity.",
    errGeneric:     "Error",
    errNameRequired:"Name is required.",
    errFetchStock:  "Could not load stock",
    connectionError:"Connection error",
    error_:         "Error",
    // Category labels
    catRawMaterial:  "Raw Material",
    catConsumable:   "Consumable",
    catSemiFinished: "Semi-Finished",
    catSparePart:    "Spare Part",
    catElectronic:   "Electronic",
    catChemical:     "Chemical",
    catPackaging:    "Packaging",
  },

  maintenance_: {
    title: "Maintenance & Service",
    subtitle: "Preventive maintenance · Fault response · Service approval flow",
    refresh: "Refresh",
    loading: "Loading...",
    retry: "Retry",
    cancel: "Cancel",
    saving: "Saving...",
    update: "Update",
    plan: "Schedule",
    detail: "Detail",
    actions: "Actions",
    approve: "Approve",
    reject: "Reject",
    statusPending:    "Pending",
    statusInProgress: "In Progress",
    statusCompleted:  "Completed",
    statusCancelled:  "Cancelled",
    statusOverdue:    "Overdue",
    statusLabel:      "Status",
    allStatuses:      "All Statuses",
    typePreventive:  "Preventive",
    typeCorrective:  "Corrective",
    typePredictive:  "Predictive",
    typeInspection:  "Inspection",
    typeCalibration: "Calibration",
    allTypes:        "All Types",
    priorityLow:      "Low",
    priorityNormal:   "Normal",
    priorityHigh:     "High",
    priorityCritical: "Critical",
    faultMechanical:  "Mechanical Failure",
    faultElectrical:  "Electrical Failure",
    faultSoftware:    "Software Error",
    faultVibration:   "Vibration / Noise",
    faultOverheat:    "Overheating",
    faultLeak:        "Leakage",
    faultCalibration: "Calibration Issue",
    faultSparePart:   "Spare Part Replacement",
    faultOther:       "Other",
    calendar:          "Maintenance Calendar",
    maintenanceShort:  "Maintenance",
    tabOverview: "Overview",
    tabParts:    "Parts Used",
    tabCost:     "Cost",
    maintenanceInfo: "Maintenance Info",
    title_:          "Title",
    machine_:        "Machine",
    type_:           "Type",
    priority_:       "Priority",
    technician:      "Assigned Technician",
    technicianShort: "Technician",
    scheduledDate:   "Scheduled Date",
    startedAt:       "Started At",
    completedAt:     "Completed At",
    estimatedHrs:    "Estimated Duration",
    actualHrs:       "Actual Duration",
    hours:           "hrs",
    description_:    "Description",
    noDescription:   "No description provided.",
    workDone:        "Work Done",
    notCompleted:    "Not completed yet.",
    nextMaintenance: "Next Maintenance",
    planned:         "Scheduled",
    partName:  "Part Name",
    stockCode: "Stock Code",
    qty:       "Qty",
    unitPrice: "Unit Price",
    total_:    "Total",
    noParts:   "No parts recorded",
    laborCost:     "Labor Cost",
    partsCost:     "Parts Cost",
    totalCost_:    "Total Cost",
    estimatedCost: "Planned Cost",
    actualCost:    "Actual Cost",
    variance_:     "Variance",
    serviceRequest:  "Service Request",
    requester:       "Requester",
    faultType_:      "Fault Type",
    approvedBy:      "Approved By",
    approvedAt:      "Approval Date",
    estimatedCostTl: "Estimated Cost",
    createServiceRequest: "Create Service Request",
    serviceRequestNote:   "Request will be sent to manager for approval",
    requestSent:          "Service Request Submitted!",
    requestSentNote:      "Your request has been sent to the manager. You can track its status in the Service Requests tab.",
    machineId_:           "Machine ID",
    selectFaultType:      "Select...",
    faultDescription:     "Fault Description",
    faultDescPlaceholder: "Describe the fault in detail. When did it start? What are the symptoms?",
    optional:             "Optional",
    contactInternal:      "Contact (Extension)",
    internalNo:           "Extension no",
    approvalFlow:         "After submitting → Manager approves → Technician assigned → Converted to maintenance plan",
    sending:              "Sending...",
    sendRequest:          "Submit Request",
    editMaintenance: "Edit Maintenance",
    newMaintenance:  "Schedule New Maintenance",
    estimatedHrsTl:  "Estimated Duration (hrs)",
    nextMaintDate:   "Next Maintenance Date",
    planMaintenance: "Schedule Maintenance",
    statTotal:   "Total Maintenance",
    statPending: "Pending",
    statOverdue: "Overdue",
    statCost:    "Total Cost",
    overdueAlert: "maintenance records are past their scheduled date! Urgent action required.",
    tabMaintenance: "Maintenance Plans",
    tabService:     "Service Requests",
    searchPlaceholder:        "Search title or machine...",
    searchServicePlaceholder: "Search machine or description...",
    recordCount:      "maintenance records",
    serviceCount:     "service requests",
    noRecords:        "No maintenance records yet.",
    noServiceRecords: "No service requests found.",
    noMatch:          "No matching records found.",
    date_: "Date",
    errFetch:        "Could not load maintenance data",
    errGeneric:      "Error",
    errMachineDesc:  "Machine ID and description are required.",
    errTitleMachine: "Title and machine ID are required.",
      machineIdPlaceholder: 'e.g. CNC-001',
},

  energyPage: {
    title: "Energy Tracking",
    subtitle: "Real-time consumption · Cost analysis · CO₂ tracking · Threshold settings",
    refresh: "Refresh",
    settings: "Settings",
    loading: "Loading...",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    detail: "Detail",
    tabOverview: "Overview",
    tabMachines: "By Machine",
    tabAnalysis: "Analysis",
    show: "Show",
    periodHourly:  "Hourly",
    periodDaily:   "Daily",
    periodMonthly: "Monthly",
    currentPower_:  "Current Power",
    todayConsump_:  "Today Consumption",
    todayCost_:     "Today Cost",
    co2Emission:    "CO₂ Emission",
    threshold:      "Threshold",
    day:            "day",
    yesterday:      "Yesterday",
    monthlyEst:     "Monthly estimate",
    monthly_:       "Monthly",
    dailyConsumption: "Daily Consumption",
    dailyCost:        "Daily Cost",
    kwhThresholdAlert:  "Daily consumption threshold exceeded",
    costThresholdAlert: "Daily cost threshold exceeded",
    energyConsumption: "Energy Consumption",
    cost_:             "Cost",
    noEnergyData:      "No energy data found",
    tariffDay:   "Day Tariff",
    tariffNight: "Night Tariff",
    tariffPeak:  "Peak Tariff",
    machine_:           "Machine",
    currentPower:       "Current Power",
    todayKwh:           "Today (kWh)",
    todayCostTl:        "Today (₺)",
    monthKwh:           "This Month (kWh)",
    monthCostTl:        "This Month (₺)",
    efficiency:         "Efficiency",
    noMachineData:      "No machine energy data found",
    machineConsumptionToday: "Today's Consumption by Machine",
    sevenDayHistory:     "7-day energy history",
    sevenDayConsumption: "7-Day Consumption",
    todayConsump:        "Today's Consumption",
    todayCost:           "Today's Cost",
    noHistoryData:       "No historical data found",
    weeklyComparison:  "Weekly Comparison",
    monthlyComparison: "Monthly Comparison",
    thisWeek:          "This Week",
    lastWeek:          "Last Week",
    thisMonth:         "This Month",
    lastMonth:         "Last Month",
    thisMonthTotal:    "This Month Total",
    thisMonthCost:     "This Month Cost",
    thisMonthCo2:      "This Month CO₂",
    lastMonthCost:     "Last Month Cost",
    yearlyEstimate:    "Yearly Estimate",
    settingsTitle:        "Energy Settings",
    sectionKwh:           "Consumption Thresholds (kWh/day)",
    sectionCost:          "Cost Thresholds (₺/day)",
    sectionCo2:           "CO₂ Thresholds (kg/day)",
    sectionPeak:          "Power Thresholds (kW)",
    sectionTariff:        "Electricity Tariffs (₺/kWh)",
    sectionNotification:  "Notification Settings",
    warningThreshold:     "Warning Threshold",
    criticalThreshold:    "Critical Threshold",
    email_:               "Email",
    smsTelegram:          "SMS / Telegram",
    errGeneric:           "Error",
  },

  kaizenPage: {
    title: "Kaizen & Lean & 5S",
    subtitle: "Continuous improvement · 5S audit · Savings tracking",
    refresh:"Refresh", loading:"Loading...", cancel:"Cancel",
    saving:"Saving...", update:"Update", submit:"Submit",
    actions:"Actions", reject:"Reject",
    statusIdea:"Idea", statusReviewing:"Reviewing", statusApproved:"Approved",
    statusImplementing:"Implementing", statusCompleted:"Completed", statusRejected:"Rejected",
    allStatuses:"All Statuses",
    catSafety:"Safety", catQuality:"Quality", catEfficiency:"Efficiency",
    catCost:"Cost", catEnvironment:"Environment", catErgonomics:"Ergonomics",
    catMaintenance:"Maintenance", catOther:"Other", allCategories:"All Categories",
    seiriLabel:"Seiri (Sort)", seiriDesc:"Remove unnecessary items",
    seitonLabel:"Seiton (Set in Order)", seitonDesc:"A place for everything",
    seisoLabel:"Seiso (Shine)", seisoDesc:"Clean and tidy workspace",
    seiketsuLabel:"Seiketsu (Standardize)", seiketsuDesc:"Set and maintain standards",
    shitsukeLabel:"Shitsuke (Sustain)", shitsukeDesc:"Maintain habits",
    tabKaizen:"Kaizen Suggestions", tabFives:"5S Audits", tabLean:"Lean Analysis",
    tabPdca:"PDCA Cycle", tabSavings:"Cost-Benefit", tabSuggestions:"System Suggestions",
    addSuggestion:"Add Suggestion", doAudit:"Conduct Audit",
    createWorkOrder:"Create Work Order", createKaizen:"Create Kaizen",
    statTotal:"Total Suggestions", statCompleted:"Completed", statOngoing:"Ongoing",
    statSaving:"Estimated Savings", statFivesScore:"5S Avg. Score",
    kaizenInfo:"Kaizen Info", category_:"Category", priority_:"Priority",
    submitter:"Submitted By", department_:"Department", machineArea:"Machine/Area",
    submitDate:"Submit Date", targetDate_:"Target Date", estimatedSaving_:"Est. Savings",
    problem_:"Problem", suggestion_:"Suggestion", result_:"Result",
    editKaizen:"Edit Kaizen", newKaizen:"New Kaizen Suggestion",
    title_:"Title", estimatedSavingTl:"Estimated Savings (₺)",
    prioLow:"Low", prioNormal:"Normal", prioHigh:"High", prioCritical:"Critical",
    problemDef:"Problem Definition", problemPh:"Describe the current situation and problem...",
    improvementSuggestion:"Improvement Suggestion", suggestionPh:"Describe your solution in detail...",
    resultNote:"Result / Implementation Note", resultPh:"Fill in after implementation...",
    editFivesAudit:"Edit 5S Audit", newFivesAudit:"New 5S Audit",
    fivesScoreHint:"Each category 0-10 points",
    auditArea:"Audit Area", auditAreaPh:"e.g. Assembly Line 1",
    auditor_:"Auditor", auditorPh:"Auditor name",
    auditDate:"Audit Date", totalScore:"Total Score", notes:"Notes",
    saveFivesAudit:"Save Audit",
    lastAuditRadar:"Last Audit Radar Chart", fivesCategoryScores:"5S Category Scores",
    auditHistory:"Audit History", noAuditYet:"No audit records yet",
    noFivesAudits:"No 5S audits conducted yet.",
    date_:"Date", area_:"Area", total_:"Total",
    searchPlaceholder:"Search suggestion title...",
    noKaizen:"No Kaizen suggestions yet. Add the first one!", noMatch:"No matching suggestions found.",
    kaizenCategoryDist:"Kaizen Category Distribution", sevenMuda:"7 Mudas (Lean Waste Types)",
    mudaOverprod:"Overproduction", mudaOverprodDesc:"Producing more than needed",
    mudaWaiting:"Waiting", mudaWaitingDesc:"Machine/material/info waiting",
    mudaTransport:"Transport", mudaTransportDesc:"Material transfer",
    mudaOverproc:"Overprocessing", mudaOverprocDesc:"Unnecessary process steps",
    mudaInventory:"Inventory", mudaInventoryDesc:"Excess raw material/WIP",
    mudaMotion:"Motion", mudaMotionDesc:"Operator movement",
    mudaDefect:"Defects/Rework", mudaDefectDesc:"Quality failures",
    count_:"Count", noData:"No data",
    totalSuggestions_:"Total Suggestions", completedCount:"Completed",
    completionRate:"Completion Rate", totalSaving_:"Total Savings",
    fivesAuditCount:"5S Audit Count", avgFivesScore_:"Avg. 5S Score",
    pcs:"pcs", suggestion__:"suggestions",
    pdcaInfo:"PDCA: Plan → Do → Check → Act — 4-stage implementation cycle for each Kaizen",
    pdcaPlanDesc:"Problem analysis, goal setting, solution planning",
    pdcaDoDesc:"Pilot implementation, resource allocation, action taking",
    pdcaCheckDesc:"Result measurement, target comparison, analysis",
    pdcaActDesc:"Standardize or revise, roll out",
    suggestionInStage:"suggestions in this stage",
    activePdca:"Active PDCA Processes", noActivePdca:"No active PDCA processes found",
    kaizen_:"Kaizen", pdcaPhase:"PDCA Phase", responsible:"Responsible",
    totalEstSaving:"Total Estimated Savings", completedKaizen:"Completed Kaizen",
    avgSavingPerK:"Avg. Savings/Kaizen",
    categorySavingAnalysis:"Savings Analysis by Category",
    realized:"Realized", completed_:"completed",
    noKaizenData:"No Kaizen data found", roiAnalysis:"Completed Kaizen ROI Analysis",
    implCost:"Implementation Cost", payback:"Payback", monthShort:"mo",
    noCompletedKaizen:"No completed Kaizen found",
    sysInfo:"The system analyzes production data to generate automatic Kaizen suggestions.",
    thresholdSettings:"Threshold Settings", thresholdValues:"Analysis Thresholds",
    oeeThreshold:"OEE Threshold (%)", fireThreshold:"Scrap Rate Threshold (%)",
    tempThreshold:"Temperature Threshold (°C)", energyThreshold:"Energy Cost Threshold (₺)",
    reanalyze:"Re-analyze",
    noSuggestions:"No System Suggestions",
    noSuggestionsNote:"All machines are operating within defined thresholds.",
    machine_:"Machine", saving_:"savings", recommendedActions:"Recommended Actions",
    errFetch:"Could not load Kaizen data", errGeneric:"Error",
    errAreaAuditor:"Area and auditor are required.", errTitleProblem:"Title and problem description are required.",
  },

  // Dashboard PL & extra
  pl: {
    title: "P&L Summary (Last 30 Days)",
    salesRevenue: "Sales Revenue",
    grossProfit: "Gross Profit",
    opExpense: "Operating Expense",
    netProfitLoss: "Net Profit/Loss",
    incomeItems: "💹 INCOME ITEMS",
    expenseItems: "📊 EXPENSE ITEMS",
    scrapRevenue: "Scrap Revenue",
    returnLoss: "Return Loss",
    brutProfit: "Gross Profit",
    productionCost: "Production Cost",
    fireLoss: "Scrap Loss",
    labor: "Labor (Payroll)",
    energy: "Energy",
    maintenance: "Maintenance",
    totalExpense: "Total Expense",
    personnel: "personnel",
    normal: "Regular",
    overtime: "Overtime",
    labor_short: "Labor",
    parts: "Parts",
    netProfit: "NET PROFIT/LOSS",
  },

  userManagement: {
    title: "User Management",
    subtitle: "Manage users, roles, and module access",

    roles: {
      admin: "System Administrator",
      manager: "General Manager",
      production_manager: "Production Manager",
      quality_manager: "Quality Manager",
      warehouse_chief: "Warehouse Chief",
      maintenance_chief: "Maintenance Chief",
      hr_manager: "HR Manager",
      accountant: "Accounting",
      technician: "Technician",
      warehouse: "Warehouse Staff",
      operator: "Operator",
      purchasing: "Purchasing",
      dis_ticaret_mudur: "Foreign Trade Manager",
      dis_ticaret_uzman: "Foreign Trade Specialist",
      dis_ticaret_temsilci: "Foreign Trade Representative",
      ic_satis_mudur: "Domestic Sales Manager",
      ic_satis_uzman: "Domestic Sales Specialist",
      ic_satis_temsilci: "Domestic Sales Representative",
    },

    departments: {
      foreignTrade: "Foreign Trade",
      domesticSales: "Domestic Sales",
    },

    modules: {
      dashboard: "Dashboard",
      machines: "Machines",
      workorders: "Work Orders",
      quality: "Quality & Shipping",
      stock: "Stock",
      maintenance: "Maintenance & Service",
      energy: "Energy",
      kaizen: "Kaizen",
      lean: "Lean",
      fives: "5S Audit",
      hr: "HR & Payroll",
      shifts: "Shift Planning",
      reports: "Reports",
      admin: "Factory Panel",
      users: "User Management",
      financial: "Financial",
      ncr: "NCR & CAPA",
      scrap: "Scrap & Recycling",
      sales: "Sales Orders",
      purchasing: "Purchasing",
    },

    regions: {
      domestic: "Domestic",
      foreign: "Foreign",
      all: "All",
    },

    levels: {
      manager: "Manager",
      chief: "Specialist",
      representative: "Representative",
    },

    usernameRequired: "Username is required.",
    passwordRequired: "Password is required.",
    genericError: "Error",
    editUser: "Edit User",
    newUser: "New User",
    username: "Username",
    role: "Role",
    password: "Password",
    newPassword: "New Password (leave blank to keep unchanged)",
    passwordLeaveBlank: "Leave blank if you do not want to change it",
    region: "Region",
    level: "Level",
    select: "— Select —",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    update: "Update",
    activeUser: "Active user",
    saving: "Saving...",
    addUser: "Add User",
    loading: "Loading...",
    noUsers: "No users found",
    totalUsers: "Total Users",
    active: "Active",
    passive: "Inactive",
    roleCount: "Role Count",
    usersTab: "Users",
    permissionsTab: "Module Access",
    salesRegion: "Sales Region",
    status: "Status",
    actions: "Actions",
    you: "You",
    edit: "Edit",
    delete: "Delete",

    permissionsLocked:
      "Access for Admin and General Manager roles cannot be changed — they have access to all modules.",
    moduleAccess: "Module Access",
    allModulesAccess: "This role can access all modules",
    modulesAccessCount: "{count} modules accessible",
    selectAll: "Select All",
    clear: "Clear",
    fullAccess: "This role has full access to all modules",
    permissionsSaved: "Access settings saved!",
    savePermissions: "Save Access",
    accessSummary: "All Roles — Access Summary",
    module: "Module",

    deleteUser: "Delete User",
    deleteConfirm: "Are you sure you want to delete {username}?",
    irreversible: "This action cannot be undone.",
    yesDelete: "Yes, Delete",
  },

  ncrPage: {
    severityMinor: "Minor",
    severityMajor: "Major",
    severityCritical: "Critical",

    statusOpen: "Open",
    statusUnderReview: "Under Review",
    statusPendingApproval: "Pending Approval",
    statusApproved: "Approved",
    statusClosed: "Closed",
    statusCancelled: "Cancelled",

    dispositionRework: "Rework",
    dispositionRemanufacture: "Remanufacture",
    dispositionReplacement: "Replacement",
    dispositionScrap: "Scrap",
    dispositionUseAsIs: "Use As Is",
    dispositionReturnSupplier: "Return to Supplier",
    dispositionPending: "Pending Decision",

    categoryDimensional: "Dimensional",
    categoryVisual: "Visual",
    categoryFunctional: "Functional",
    categoryMaterial: "Material",
    categoryProcess: "Process",
    categoryDocumentation: "Documentation",
    categoryAssembly: "Assembly",
    categorySupplier: "Supplier",
    categoryWelding: "Welding",
    categoryProduction: "Production",
    categoryQuality: "Quality",
    categoryCustomer: "Customer",
    categoryOther: "Other",

    capaStatusOpen: "Open",
    capaStatusInProgress: "In Progress",
    capaStatusCompleted: "Completed",
    capaStatusVerified: "Verified",
    capaStatusClosed: "Closed",

    priorityLow: "Low",
    priorityMedium: "Medium",
    priorityHigh: "High",
    priorityCritical: "Critical",


    // New NCR form
    newNcrTitle: "New NCR Record",
    newNcrSubtitle: "Non-Conformance Report — Nonconforming Product Record",
    basicInformation: "Basic Information",
    sourceType: "Source Type",
    detectionDate: "Detection Date",
    department: "Department",
    departmentPlaceholder: "Production, Quality...",
    productCode: "Product Code",
    productCodePlaceholder: "Product code...",
    workOrderNo: "Work Order No",
    salesOrderNo: "Order No",
    customer: "Customer",
    customerPlaceholder: "Customer name",
    nonconformityDetails: "Nonconformity Details",
    affectedQuantity: "Affected Quantity",
    costImpact: "Cost Impact",
    nonconformityDescription: "Nonconformity Description",
    nonconformityPlaceholder: "Describe the nonconformity in detail...",
    createNcr: "Create NCR",

    editNcr: "Edit NCR",
    sourceInternalAudit: "Internal Audit",
    analysisDecision: "Analysis & Decision",
    rootCauseAnalysis: "Root Cause Analysis",
    rootCausePlaceholder: "Why did it occur? 5 Whys, Fishbone...",
    immediateActionPlaceholder: "What immediate action was taken?",
    notes: "Notes",
    update: "Update",

    ncrProductRequired: "Product code is required",
    ncrDescriptionRequired: "Description is required",
    ncrQuantityRequired: "Affected quantity is required and must be greater than 0",
    ncrDepartmentRequired: "Department is required",
    ncrCustomerRequired: "Customer is required",
    ncrSaveFailed: "Could not save the NCR record",

    sourceQualityCheck: "Quality Control",
    sourceProduction: "Production",
    sourceSupplier: "Supplier",
    sourceCustomerComplaint: "Customer Complaint",
    sourceOther: "Other",

    severityMinorOption: "Minor — Low",
    severityMajorOption: "Major — High",
    severityCriticalOption: "Critical — Urgent",

    criticalNcrTitle: "CRITICAL NCR",
    criticalNcrInfo: "Requires the Quality Manager → Production Manager → General Manager approval chain.",
    majorNcrTitle: "MAJOR NCR",
    majorNcrInfo: "Requires Quality Manager and Production Manager approval.",

    // Customer Return form
    returnTitle: "Customer Return",
    returnSubtitle: "Creating a return automatically opens an NCR and notifies the relevant departments",
    returnType: "Return Type",
    returnRefund: "Refund",
    returnReplacement: "Replacement",
    returnCustomerName: "Customer Name",
    returnCustomerPlaceholder: "Enter customer name...",
    returnSelectOrder: "Select Order",
    returnSelectOrderPlaceholder: "Select an order",
    returnSelectProduct: "Select Product",
    returnSelectProductPlaceholder: "Select a product",
    returnQuantity: "Return Quantity",
    piecesSold: "pcs sold",
    returnDate: "Return Date",
    severity: "Severity",
    returnReason: "Return Reason",
    returnReasonPlaceholder: "Explain in detail why the customer returned the product...",
    cancel: "Cancel",
    saving: "Saving...",
    createReturnRecord: "Create Return Record",
    returnProductRequired: "Product code is required",
    returnCustomerRequired: "Customer is required",
    returnQuantityRequired: "Quantity is required",
    returnSaveFailed: "Could not save the return record",

    // NCR quality cost
    costInternal: "Internal Failure",
    costInternalHint: "Labor, machine",
    costExternal: "External Failure",
    costExternalHint: "Shipping, penalty",
    costRework: "Rework",
    costReworkHint: "Subcontracting, operation",
    costOtherImpact: "Other Impact",
    costOtherImpactHint: "General cost",
    total: "Total",
    recurrenceWarning: "This product has received an NCR for the {count}. time!",
    saveCost: "Save Cost",


    // NCR Detail
    genericError: "Error",
    closeConfirm: "The NCR will be closed. Are you sure?",
    closedNote: "Closed",
    category: "Category",
    capaCount: "CAPA Count",
    rootCause: "Root Cause",
    immediateAction: "Immediate Action",
    notEnteredYet: "Not entered yet",
    approvalChain: "Approval Chain",
    qualityManager: "Quality Manager",
    productionManager: "Production Manager",
    generalManager: "General Manager",
    pending: "Pending",
    notRequired: "Not Required",
    approvalDecision: "Approval / Decision",
    decision: "Decision",
    note: "Note",
    approvalNotePlaceholder: "Approval note...",
    processing: "Processing...",
    approveApply: "Approve & Apply",
    closeNcr: "Close NCR",
    remanufactureInfo: "An automatic work order will be created upon approval.",
    reworkInfo: "A Rework work order (RWK-XXXX) will be created automatically upon approval. The operator will correct the existing product.",
    replacementInfo: "If stock is available, a shipment will be created directly. Otherwise, an RPL work order will be created.",
    returnSupplierInfo: "The Purchasing department will be notified.",
    scrapInfo: "A record will automatically be created in the Scrap module upon approval.",
    scrapRevenue: "SCRAP REVENUE",
    scrapRevenuePlaceholder: "Amount received from the scrap dealer...",
    capaRecords: "CAPA Records",
    addCapa: "Add CAPA",
    noCapaForNcr: "No CAPA has been created for this NCR yet.",
    // CAPA form
    newCapa: "New CAPA",
    editCapa: "Edit CAPA",
    capaSubtitle: "Corrective / Preventive Action",
    capaType: "CAPA Type",
    capaCorrectiveOption: "Corrective — Resolve the existing problem",
    capaPreventiveOption: "Preventive — Prevent recurrence",
    capaTitlePlaceholder: "CAPA title...",
    problemStatement: "Problem Statement",
    problemStatementPlaceholder: "What is the problem?",
    analysisMethod: "Analysis Method",
    capaRootCausePlaceholder: "Root cause analysis...",
    actionPlan: "Action Plan",
    actionPlanPlaceholder: "What will be done?",
    responsiblePerson: "Responsible Person",
    responsiblePersonPlaceholder: "Full Name",
    actionCost: "Action Cost",
    createCapa: "Create CAPA",

    rootMethod5Why: "5 Whys",
    rootMethodFishbone: "Fishbone",
    rootMethodPareto: "Pareto",
    rootMethodFmea: "FMEA",
    rootMethodOther: "Other",

    capaTitleRequired: "Title is required",
    capaTargetDateRequired: "Target date is required",
    capaSaveFailed: "Could not save the CAPA record",

    corrective: "Corrective",
    preventive: "Preventive",
    responsible: "Responsible",
    target: "Target",
    qualityCostEntry: "Quality Cost Entry",
    approvalHistory: "Approval History",
    close: "Close",


    // NCR main screen
    pageSubtitle: "Non-Conformance Report · Corrective & Preventive Action · ISO 9001 Clauses 8.7 & 10.2",
    totalNcr: "Total NCR",
    open: "Open",
    underReview: "Under Review",
    pendingApproval: "Pending Approval",
    critical: "Critical",
    totalCost: "Total Cost",
    loading: "Loading...",
    searchPlaceholder: "NCR no., product code, customer...",
    allSeverities: "All Severities",
    allStatuses: "All Statuses",
    ncrRecords: "NCR Records",
    noNcrRecords: "No NCR records found",
    createFirstNcr: "Create First NCR",

    // CAPA & Analytics main screen
    title: "Title",
    type: "Type",
    targetDate: "Target Date",
    progress: "Progress",
    priority: "Priority",
    severityDistribution: "Severity Distribution",
    categoryDistribution: "Category Distribution",
    decisionDistribution: "Decision Distribution",
    count: "Count",
    noData: "No data",
    last30DaysNcr: "NCRs in Last 30 Days",
    closedCount: "Closed",
    totalCapa: "Total CAPA",

    noCapaRecords: "No CAPA records found. You can create a CAPA from an NCR record.",

    // Customer Return main screen
    listTab: "NCR List",
    returnsTab: "Customer Returns",
    returnPaginationLabel: "return",
    analyticsTab: "Analytics",
    addReturnRecord: "Add Return Record",
    returnInfo: "When a customer return is created, an NCR is opened automatically and the Quality and Production managers are notified. Click a row to view the NCR details.",
    returnRecords: "Customer Return Records",
    records: "records",
    product: "Product",
    date: "Date",
    status: "Status",
    noReturnRecords: "No customer return records found",
    piece: "pcs",
  },


  productsPage: {
    title: "Product Cards",
    mainSubtitle: "Product recipe (BOM) · Outsource operations · Production routing · MRP calculation",
    template: "📥 Template ▾",
    import: "📤 Import ▾",
    newProductCard: "+ New Product Card",
    editProductCard: "Edit Product Card",
    description: "Description",
    descriptionOptional: "Description (optional)",
    productInformation: "📋 Product Information",
    categoryPlaceholder: "Automotive, Agriculture...",
    purchasedPart: "Purchased Part",
    semiFinishedType: "Semi-Finished",
    showInSales: "Show in Sales",
    inProcessQc: "In-Process QC",
    stockable: "Can Be Stocked",
    drawingFile: "📐 Technical Drawing",
    pdfDocument: "📄 PDF Document",
    unitCostUpper: "UNIT COST",
    totalProducts: "Total Products",
    ownProduction: "Own Production",
    externallyPurchased: "Externally Purchased",
    setKit: "Set/Kit",
    bomDefined: "BOM Defined",
    allTypes: "All Types",
    clickNewProductHint: "Click + New Product Card",

    subtitle: "Manage products, BOMs, costs and production definitions",

    loading: "Loading...",
    saving: "Saving...",
    save: "💾 Save",
    cancel: "Cancel",

    productCode: "Product Code",
    productName: "Product Name",
    productNameRequired: "Product code and name are required.",
    productNamePlaceholder: "Enter product name...",

    type: "Type",
    category: "Category",
    unit: "Unit",
    material: "Material",
    materialPlaceholder: "St37, Aluminum...",
    minimumStock: "Minimum Stock",
    reorderQuantity: "Reorder Quantity",

    manufactured: "Manufactured",
    purchased: "Purchased",
    set: "Set",
    service: "Service",

    categoryFinished: "Finished Product",
    categorySemiFinished: "Semi-Finished",
    categoryRawMaterial: "Raw Material",
    productCategory: "Product Category",
    categoryMachinedPart: "Machined Part",
    categoryCommercialProduct: "Commercial Product",
    categoryConsumable: "Consumable",

    requiresAssembly: "Assembly Required",

    unitCost: "Unit Cost",
    salePrice: "Sale Price",

    searchPlaceholder: "🔍 Search product code, name or category...",
    noProducts: "No product cards yet",
    noMatch: "No matching product found",

    bom: "BOM",
    outsource: "Outsource",
    sales: "Sales",

    templateProducts: "📦 Product Cards",
    templateBom: "🔩 BOM / Recipe",
    templateOutsource: "🏭 Outsource Operations",
    export: "📊 Export",

    raw: "Raw Material",
    purchasedMaterial: "Purchased",
    semiFinished: "Semi-Finished",
    subAssembly: "Sub-Assembly",

    bomTree: "BOM Tree",
    bomDataNotFound: "BOM data not found",
    mainWorkOrder: "Main Work Order",
    sequenceNo: "Sequence No",
    totalMaterialCost: "Total material cost",
    createAssemblyWorkOrder: "🔧 Create Assembly Work Order",

    materialColumn: "Material",
    quantity: "Quantity",
    stock: "Stock",
    cost: "Cost",

    detailGeneralInfo: "📋 General Information",
    detailRecipe: "🔩 Recipe",
    detailOutsource: "🏭 Outsource",
    detailOperations: "⚙️ Operations",
    detailBomTree: "🌳 BOM Tree",
    detailMrpCost: "📊 MRP / Cost",
    detailFiles: "📁 Files",

    drawingNo: "Drawing No",
    revision: "Revision",
    weight: "Weight",
    standardTime: "Standard Time",

    costSummary: "💰 Cost Summary",
    rawMaterialCost: "Raw Material",
    outsourceCost: "Outsource",
    laborCost: "Labor",
    totalCost: "Total",
    profitMargin: "Profit Margin",

    deleteConfirm: "Delete this item?",

    productRecipeTitle: "🔩 Product Recipe (BOM)",
    addMaterial: "+ Add Material",
    materialName: "Material Name",
    materialCode: "Material Code",
    unitPrice: "Unit Price",
    noMaterials: "No materials added.",

    select: "Select",
    sequence: "Sequence",
    operation: "Operation",
    supplier: "Supplier",
    leadTime: "Lead Time",
    leadTimeDays: "Lead Time (days)",

    outsourceTitle: "🏭 Outsource Operations",
    addOutsource: "+ Add Outsource Operation",
    noOutsource: "No outsource operations defined.",

    productionOperationsTitle: "⚙️ Production Operations (Routing)",
    addOperation: "+ Add Operation",
    operationName: "Operation Name",
    operationPlaceholder: "Turning, Milling...",
    department: "Department",
    machine: "Machine",
    setup: "Setup",
    setupMinutes: "Setup (min)",
    cycle: "Cycle",
    cycleMinutes: "Cycle (min)",
    noOperations: "No operations defined.",

    forPieces: "pieces",
    laborSsi: "Labor + Social Security",
    shortageWarning: "⚠️ Materials are missing! Purchasing is required before production can start.",

    unitQuantity: "Unit Quantity",
    totalRequired: "Total Required",
    inStock: "In Stock",
    shortage: "Shortage",
    status: "Status",
    ready: "✓ Ready",
    missing: "✗ Missing",

    calculate: "Calculate",
    enterQtyCalculate: "Enter a quantity and click \"Calculate\"",

    // RC1.6I.3 — final Products localization
    error: "Error",
    connectionError: "Connection error",
    deleteError: "Delete error",
    delete: "Delete",
    download: "Download",

    productType: "Product Type",
    productLabel: "product",

    fileOther: "📁 Other",
    fileUploaded: "✅ File uploaded",
    fileDeleted: "✅ File deleted",
    uploadFile: "📤 Upload File",
    fileNotePlaceholder: "Note about the file...",
    selectFile: "📁 Select File",

    operationNameRequired: "Operation Name *",
    outsourceOperationPlaceholder: "Sandblasting, Galvanizing...",

    mrpCalculation: "📊 MRP Calculation"

  },

  assemblyPage: {
    title: "Assembly Module",
    subtitle: "Work orders ready for assembly and currently in progress",
    refresh: "Refresh",
    loading: "Loading...",
    noReadyWorkOrders: "No work orders ready for assembly",
    noReadyWorkOrdersHint: "They will appear here when all sub-work orders are completed",
    completedAssemblies: "Completed Assemblies",
    hide: "Hide",
    show: "Show",
    perPage: "Per page",
    records: "records",
    piece: "pcs",

    currentStatus: "Current Status",
    materialsLoading: "Loading materials...",
    allMaterialsReady: "All materials are ready — Assembly can be started",
    missingMaterialPurchaseRequired: "Material shortage — A purchase request must be created",
    productionMaterials: "Materials from Production",
    warehouseMaterials: "Materials from Warehouse",
    required: "Required",
    inWarehouse: "In Warehouse",
    warehouseReady: "Ready in Warehouse",
    missing: "Missing",

    ready: "✅ Ready",
    waiting: "⏳ Waiting",
    delivered: "✅ Delivered",
    requestSent: "📨 Request Sent",
    inStock: "🟢 In Stock",
    outOfStock: "🔴 Out of Stock",
    request: "Request",

    startAssembly: "Start Assembly",
    completeAssembly: "Complete Assembly",
    completedQuantity: "Completed Quantity",
    notes: "Notes",
    cancel: "Cancel",
    approve: "Approve",

    assemblyStarted: "Assembly started ✅",
    assemblyCompletedSuccess: "Assembly completed ✅",
    warehouseRequestSent: "Warehouse request sent ✅",
    requestCreateFailed: "Could not create request",
    connectionError: "Connection error",
    error: "Error",

    finalQcWaiting: "Waiting for Final QC",
    finalQcWaitingHint: "Assembly is complete. Perform Final QC from the Quality & Shipment module.",
    finalQcPassedCompleted: "Final QC Passed - Completed",
    completedReadyShipment: "This work order has been completed successfully and is ready for shipment.",

    statusDraft: "Draft",
    statusPlanned: "Planned",
    statusReleased: "Released",
    statusInProgress: "In Production",
    statusQcPending: "Waiting for In-Process QC",
    statusQcPassed: "In-Process QC Passed",
    statusAssemblyPending: "Waiting for Assembly",
    statusAssemblyInProgress: "In Assembly",
    statusAssemblyDone: "Assembly Completed",
    statusAssemblyCompleted: "Assembly Completed",
    statusFinalQcPending: "Waiting for Final QC",
    statusFinalQcPassed: "Final QC Passed",
    statusFinalQcFailed: "Final QC Failed",
    statusFinalQc: "Final QC",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
  },


  aiAssistant: {
    title: "Opement IQ Assistant",
    welcome: "Hello! I'm Opement IQ Smart Assistant. I can answer questions about your factory data. 🏭",
    online: "Online",
    offline: "Offline",
    thinking: "Thinking...",
    placeholder: "Ask a question...",
    errorPrefix: "Error",
    unknownError: "Unknown error",
    connectionError: "Connection error. Please try again.",
    speechUnsupported: "Your browser does not support voice input.",
    quickOee: "What is the OEE this month?",
    quickCriticalStock: "Is there any critical stock?",
    quickScrapRate: "What is the latest scrap rate?",
    quickMaintenance: "Is there any pending maintenance?",
  },

  adminPanel: {
    title: "🎛️ Factory Management Panel",
    subtitle: "Live monitoring · Drag-and-drop layout · Auto refresh (30 sec)",
    lastUpdate: "Last",
    reset: "Reset",
    save: "Save",
    edit: "Edit",
    tabPanel: "🎛️ Factory Panel",
    tabPermissions: "🔐 Content Permissions",
    editModeHint: "Edit Mode — Drag widgets to reorder them",
    panelLoading: "Loading panel...",

    widgetTitles: {
      oeeGauges: "🏭 OEE - By Machine",
      productionChart: "📈 Production Chart",
      alarmList: "🚨 Recent Alarms",
      energy: "⚡ Energy Consumption",
      criticalStock: "📦 Critical Stock Levels",
      kaizenSummary: "🔄 Kaizen Summary",
      machineMap: "🗺️ Machine Status Map",
      lossSummary: "💰 Financial Loss Analysis",
      mrpCost: "💰 MRP / Cost Information",
    },
  

    loading: "Loading...",
    permissionsTitle: "🔐 Content Permission Management",
    saved: "Saved",
    saving: "Saving...",
    enableAll: "Enable All",
    disableAll: "Disable All",
    visible: "Visible",
    hidden: "Hidden",
    roleSelection: "Role Selection",
    moduleSelection: "Module Selection",

    permissionModules: {
      dashboard: "📊 Dashboard",
      reports: "📄 Reports",
      salesorders: "🛒 Sales Orders",
      machines: "🏭 Machines",
      workorders: "📋 Work Orders",
      products: "📦 Products",
      stock: "🏪 Stock",
      purchasing: "🛒 Purchasing",
      hr: "👥 HR & Payroll",
    },

    roles: {
      admin: "👑 System Administrator",
      manager: "🏢 General Manager",
      production_manager: "🏭 Production Manager",
      quality_manager: "✅ Quality Manager",
      warehouse_chief: "📦 Warehouse Chief",
      maintenance_chief: "🔧 Maintenance Chief",
      hr_manager: "👥 HR Manager",
      warehouse: "🏪 Warehouse Staff",
      operator: "👷 Operator",
      purchasing: "🛒 Purchasing",
      dis_ticaret_mudur: "✈️ Foreign Trade Manager",
      dis_ticaret_uzman: "✈️ Foreign Trade Specialist",
      dis_ticaret_temsilci: "✈️ Foreign Trade Representative",
      ic_satis_mudur: "🏠 Domestic Sales Manager",
      ic_satis_uzman: "🏠 Domestic Sales Specialist",
      ic_satis_temsilci: "🏠 Domestic Sales Representative",
    },

    permissionItems: {
      stat_oee: "📊 OEE Card",
      stat_production: "🏭 Total Production Card",
      stat_alarms: "🚨 Active Alarms Card",
      stat_loss: "💰 Monthly Loss Card",
      widget_pl: "💹 Profit/Loss Summary",
      widget_oee_gauges: "📈 OEE by Machine",
      widget_production: "📈 Production Chart",
      widget_kaizen: "🔄 Kaizen Summary Widget",
      widget_loss: "💸 Financial Loss Widget",
      tab_dashboard: "📊 Management Dashboard Tab",
      tab_sales_perf: "💼 Sales Performance Tab",
      tab_personnel: "👥 Personnel Reports Tab",
      tab_reports: "📄 Report Generation Tab",
      tab_history: "📋 History Tab",
      btn_new_order: "➕ New Order / Work Order",
      btn_cancel: "🚫 Cancel Button",
      col_temperature: "🌡️ Temperature Column",
      fault_history: "🔧 Fault History",
      btn_export_excel: "📥 Export to Excel",
      btn_complete: "✅ Complete Production",
      btn_runtime_start: "▶ Start Production",
      btn_downtime_reason: "⏸ Select Downtime Reason",
      col_operator: "👤 Operator Column",
      tab_materials: "📋 Product BOM Tab",
      tab_audit: "📜 History Tab",
      action_tree: "🌳 Tree Action",
      action_detail: "👁 Detail Action",
      col_supplier: "🏢 Supplier Column",
      col_salary: "💰 Salary Information",
      tab_leave: "🏖️ Leave Tab",
    },

    widgets: {
      production: "Production",
      today: "Today",
      cost: "Cost",
      completed: "Completed",
      inProgress: "In Progress",
      pending: "Pending",
      total: "Total",
      saving: "Savings",
      statusRunning: "Running",
      statusStopped: "Stopped",
      statusFault: "Fault",
      statusMaintenance: "Maintenance",
      statusIdle: "Idle",
      dataLoading: "Loading data...",
      noData: "No data",
      noActiveAlarms: "No active alarms",
      noChartData: "No chart data",
      noCriticalStock: "No critical stock",
      noKaizen: "No Kaizen records",
      noFinancialData: "No financial data",
      dailyLoss: "Daily Loss",
      monthlyLoss: "Monthly Loss",
      machine: "Machine",
    },
},
};

export default en;
